<template lang="pug">
  .inicio-main-dash.inicio-main-dash-payment.payment-quotes(style="width:100%; align-items: stretch;")
    PagoEfectivoPopupDetalle(:popupPagoEfectivo="pagoEfectivoDetalle" @popupCodigoPago="confirmacionCodigoPago")
    CodigoPago(:popupCodigoPagoProp="{popupCodigoDetalle,codigoPagoEfectivo,correoPagoEfectivo}" @popupCodigoPagoMethod="closeCodigoPago")
    ActualizarDatos(:popupActualizarDatos="{switchActualizarDatos, medioDePago}" @popupActulizarDatosMethod="closeActualizarDatos")
    .inicio-panel.mt-2.border-radius-top.panel-full-height(xs12 sm12 md8 lg12)
      .inicio-panel-content
        //- VISTA DE POLIZAS
        v-layout#main-cvc-content(row wrap v-if="sectionSelectPolicy")
          //- v-flex(xs12 md2 lg2)
          v-flex(xs12 md5 lg5)
            v-layout(row wrap)
              v-flex(xs12 md12 lg12)
                h2.title-main Mis pagos
              v-flex(xs12 md12 lg12)
                p.text-instruction Elige el seguro que deseas pagar
            div.list-container
              v-layout.polizas.g-align-center(row wrap v-for="(poliza, index) in polizasDisponibles" :key="poliza.policyNumber" :class="{'card-items-pdc-selected': poliza.selected}" @click="goToSelectQuotes(poliza, 1)")
                v-flex(xs1 md1 lg1)
                v-flex(xs3 md3 lg3)
                  v-img(:src="productsIcons[poliza.image]" style="width: 80px;")
                v-flex(xs7 md7 lg7)
                  v-card-title.omnesMedium(primary) {{ poliza.name === 'Vida Cash' ? 'Vida con Devolución' : poliza.name }}
                  v-card-text.omnesRegular.numeroPoliza
                    span N° de póliza:&nbsp;
                    | {{ poliza.policyNumber }}
                  v-card-text(v-if="poliza.pendingQuotes >= 0")
                    span.omnesRegular(:class="(poliza && poliza.pendingQuotes == 0) ? 'p-green' : 'p-red'")
                      | {{((poliza.pendingQuotes == 0) ? ((poliza.cuotas.length > 0) ?'¡Puedes adelantar cuotas!':'') : `Tienes ${poliza.pendingQuotes} cuota${(poliza.pendingQuotes > 1)?'s':''} pendiente${(poliza.pendingQuotes > 1)?'s':''}`)}}
                v-flex(xs1 md1 lg1)
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.31002 6.70978C9.21732 6.80229 9.14377 6.91218 9.09359 7.03315C9.04341 7.15413 9.01758 7.28381 9.01758 7.41478C9.01758 7.54575 9.04341 7.67543 9.09359 7.7964C9.14377 7.91738 9.21732 8.02726 9.31002 8.11978L13.19 11.9998L9.31002 15.8798C9.12304 16.0668 9.018 16.3203 9.018 16.5848C9.018 16.8492 9.12304 17.1028 9.31002 17.2898C9.497 17.4768 9.7506 17.5818 10.015 17.5818C10.2794 17.5818 10.533 17.4768 10.72 17.2898L15.31 12.6998C15.4027 12.6073 15.4763 12.4974 15.5265 12.3764C15.5766 12.2554 15.6025 12.1257 15.6025 11.9948C15.6025 11.8638 15.5766 11.7341 15.5265 11.6132C15.4763 11.4922 15.4027 11.3823 15.31 11.2898L10.72 6.69978C10.34 6.31978 9.70002 6.31978 9.31002 6.70978Z" fill="#0855C4"/>
                  </svg>
        //- VISTA DE CUOTAS
        v-layout.main-cvc-content(row wrap v-if="sectionSelectQuotes")
          v-layout(row wrap)
            v-flex.container-list-policy-quotes(lg6)
              v-flex.only-desktop
                v-flex(xs12 md12 lg12)
                  h2.title-main Mis pagos
                v-flex(xs12 md12 lg12)
                  p.text-instruction Elige el seguro que deseas pagar
              v-flex.only-mobile(xs12 md12 lg12)
                p.text-instruction Selecciona las cuotas que deseas pagar comenzando por la más antigua:

              v-flex.scroll-policies.list-container(:class="{'flex.policies-article-only-one': polizasDisponibles.length < 2}")
                v-layout.flex.polizas.policies-horizontal.g-align-center(row wrap v-for="(poliza, index) in polizasDisponibles" :key="poliza.policyNumber" :class="{'card-items-pdc-selected': poliza.selected}" @click="goToSelectQuotes(poliza, 2)")
                  v-flex(xs1 md1 lg1)
                  v-flex(xs3 md3 lg3)
                    v-img(:src="productsIcons[poliza.image]" style="width: 80px;")
                  v-flex(xs7 md7 lg7)
                    v-card-title.omnesMedium(primary) {{ poliza.name === 'Vida Cash' ? 'Vida con Devolución' : poliza.name }}
                    v-card-text.omnesRegular.numeroPoliza
                      span N° de póliza:&nbsp;
                      | {{ poliza.policyNumber }}
                    v-card-text(v-if="poliza.pendingQuotes >= 0")
                      span.omnesRegular(:class="(poliza && poliza.pendingQuotes == 0) ? 'p-green' : 'p-red'")
                        | {{((poliza.pendingQuotes == 0) ? ((poliza.cuotas.length > 0) ?'¡Puedes adelantar cuotas!':'') : `Tienes ${poliza.pendingQuotes} cuota${(poliza.pendingQuotes > 1)?'s':''} pendiente${(poliza.pendingQuotes > 1)?'s':''}`)}}
                  v-flex(xs1 md1 lg1)
                    <svg :class="{'arrow-bottom': poliza.selected}" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.31002 6.70978C9.21732 6.80229 9.14377 6.91218 9.09359 7.03315C9.04341 7.15413 9.01758 7.28381 9.01758 7.41478C9.01758 7.54575 9.04341 7.67543 9.09359 7.7964C9.14377 7.91738 9.21732 8.02726 9.31002 8.11978L13.19 11.9998L9.31002 15.8798C9.12304 16.0668 9.018 16.3203 9.018 16.5848C9.018 16.8492 9.12304 17.1028 9.31002 17.2898C9.497 17.4768 9.7506 17.5818 10.015 17.5818C10.2794 17.5818 10.533 17.4768 10.72 17.2898L15.31 12.6998C15.4027 12.6073 15.4763 12.4974 15.5265 12.3764C15.5766 12.2554 15.6025 12.1257 15.6025 11.9948C15.6025 11.8638 15.5766 11.7341 15.5265 11.6132C15.4763 11.4922 15.4027 11.3823 15.31 11.2898L10.72 6.69978C10.34 6.31978 9.70002 6.31978 9.31002 6.70978Z" fill="#0855C4"/>
                    </svg>
            v-flex(xs12 md6 lg5)
              v-flex.only-desktop(xs12 md12 lg12)
                p.text-instruction.fs-16(:style="(!pdcPayments) ? 'color: #fff' : ''") Selecciona las cuotas que deseas pagar comenzando por la más antigua:
              v-layout
                v-tabs(style="width: 99%")
                  v-tab(v-if="pdcPayments" @click="selectTabAnalytics('Cuotas por pagar')") Cuotas por pagar
                  v-tab-item(v-if="pdcPayments")
                    .tab-item-wrapper(style="max-height: 350px; overflow-y: scroll; overflow-x: hidden;")
                      table.pdcTable
                        thead
                          tr
                            th Cuotas
                            th Estados
                            th Montos
                            th Seleccionar
                              br
                              | para pagar
                        tbody
                          tr(v-for="(cuota, index) in polizaSeleccionada.cuotas" :key="'td-'+index")
                            td {{cuota.mes}}
                            td
                              v-menu( open-on-hover :close-on-content-click='false' content-class="tooltip-bubble")
                                template(v-slot:activator='{ on }')
                                  span(
                                    v-on="on"
                                    :class="getStatusCuota(cuota)"
                                    :id="polizaSeleccionada.policyNumber+'-cuota-'+index"
                                  ) {{cuota.tipo}}
                                v-card#popover-info
                                  span {{cuota.rows[0].fechaInicioCobertura.split('-').join('/')}}
                            td {{`${polizaSeleccionada.monedaSimbolo} ${cuota.monto.toFixed(2)}`}}
                            td(style="margin-left: auto; margin-right: auto;")
                              input.i-radio--extend.scale(
                                :id="'check-box-'+index" type='radio'
                                :name="'check-box-'+index" value=''
                                :checked='cuota.selected'
                                @click="selectCuota(cuota, index)"
                                :disabled="enabledQuote(index)"
                                style="margin-left: auto; margin-right: auto; width: -webkit-fill-available;"
                              )
                              label(for='radio_actual')
                  v-tab(v-if="pdcHistory" @click="selectTabAnalytics('Historial de pagos')") Historial de pagos
                  v-tab-item(v-if="pdcHistory")
                    .tab-item-wrapper(style="max-height: 350px; overflow-y: scroll; overflow-x: hidden;")
                      table.pdcTable.history-table
                        thead
                          tr
                            th Cuota de pago
                            th Estado
                            th Monto
                            th Fecha
                        tbody
                          tr(v-for="(cuota, index) in polizaSeleccionada.historial" :key="'td-'+index")
                            td {{(cuota.mes || '').toUpperCase()}}
                            td
                              span( :id="polizaSeleccionada.policyNumber+'-cuota-'+index" class="cuota-disponible") {{cuota.estado || 'PAGADO'}}
                            td {{`${polizaSeleccionada.monedaSimbolo} ${cuota.monto}`}}
                            td(style="margin-left: auto; margin-right: auto;") {{cuota.fechaPagado}}
              //v-layout.btn-process-all-floating(row wrap)
              v-layout(row wrap style="margin-top: 2em")
                  v-flex(v-if="pdcPayments" xs12 md12 lg12 style="text-align:center;margin-bottom:1em;")
                    v-btn.omnesMedium(@click="goToVerifyData()" :disabled="paymentTotal <= 0" :class="{'back-purple':(paymentTotal > 0)}")
                      | {{ `Continuar &nbsp; &nbsp; ${polizaSeleccionada.monedaSimbolo} ${paymentTotal}`}}
                  v-flex(xs12 md12 lg12 style="text-align:center")
                    a.omnesMedium(href="#" @click="goHome('event-38-select-button-analytic')" style="color: #0855c4; font-size:17px") Volver

        //- VISTA DE RESUMEN PREVIO PAGO
        v-layout#enter-data-payment(row wrap v-if="sectionVerifyData")
          v-flex(xs12 md2 lg2)
          v-flex(xs12 md8 lg8)
            v-layout(row wrap)
              v-flex(xs12 md12 lg12)
              v-flex.container-data-payment(xs12 md12 lg12)
                v-layout(row wrap)
                  v-flex(xs12 md12 lg12)
                    h1.omnesMedium.g-text-center Resumen de tu pago
                  v-flex.subtitle-cvc(xs12 md12 lg12)
                    p(style="font-size: 17px;")
                      | Verifica el monto total a pagar de las cuotas seleccionadas
            v-layout(style="margin-top: 10px")
              table.pdcTable
                thead
                  tr
                    th Nombre del producto:
                      br
                      | {{polizaSeleccionada.name}}
                    th Poliza:
                      br
                      | {{polizaSeleccionada.policyNumber}}
                tbody
                  tr
                    td Monto total de cuotas:
                    td {{ `${polizaSeleccionada.monedaSimbolo} ${paymentTotal}`}}
                  tr
                    td Fecha de pago de cuotas:
                    td {{now()}}
            //-Pago efectivo
            PagoEfectivo(:pagoEfectivoProp="switchPagoEfectivo" @getMedioDePago="selectMedioDePago" @formaDePago="metodoDePago")

            v-layout.boton-tipo-pago(row wrap style="margin-top: 20px")
                v-flex(xs12 md12 lg12 style="text-align:center;margin-bottom:1em;")
                  v-btn.back-purple.omnesMedium(@click="goToConfirm()" :disabled="btnPagoEfectivo" style="text-transform: capitalize;") Continuar
                v-flex(xs12 md12 lg12 style="text-align:center")
                  a.omnesMedium(href="#" @click="goToSelectQuotes(polizaSeleccionada, 'back')" style="color: #0855c4; font-size:17px") Volver

        //- [ENTER DATA PAYMENT]
        v-layout#enter-data-payment(row wrap v-if="sectionEnterDataPayment")
          v-layout(row wrap)
            v-flex.container-data-payment(xs12 md12 lg12 style="margin-top: 0; padding-top: 0;")
              v-layout(row wrap)
                v-flex(xs12 md12 lg12 style="margin-top: 0;")
                  h1.omnesMedium Ingresa los datos de tu tarjeta
                v-flex.second-subtitle-cvc(xs12 md12 lg12)
                  p.omnesMedium
                    img(:src="iconSeguridad" width="17px" alt="iconSeguridad")
                    | Te encuentras en un ambiente 100 % seguro

              v-card#form-credit-card-payment-method
                v-card-text
                  v-layout(wrap row v-if="niubiz.finishGetSessionKey")
                    .i-interseguro__content__form
                      Niubiz(
                        :configuration="niubiz.configuration"
                        :elementStyle="niubiz.styles"
                        :dataClient="niubiz.pagador"
                        :buttonAmount="`${polizaSeleccionada.monedaSimbolo} ${paymentTotal}`"
                        :showTermsConditions="true"
                        :showCheckRecurrent="niubiz.checkRecurrent"
                        :showCheckOptionTrue="true"
                        buttonCurrency=""
                        affiliationText="Deseo y autorizo que mis próximas cuotas se cobren automáticamente"
                        :buttonText="niubiz.botonTexto"
                        @openloader="showLoader"
                        @hideloader="hideLoader"
                        @carderror="onPaymentError"
                        @open-conditions="showTerms"
                        @check-change-recurrent="changeCheckRecurrent"
                      )
                  v-card-actions.update-payment-actions
                    v-layout
                      v-flex.text-xs-center
                        a.omnesMedium(href="#" @click="closeDialogMethodPayment($event)" style="color: #0855c4; font-size:17px") Volver
        //- [SUCCESSFULL CHANGE PAYMENT]
        v-layout#successfull_change_payment(row wrap v-if="sectionSuccessfullChangePayment")
          v-flex(xs12 md2 lg2)
          v-flex(xs12 md8 lg8)
            v-layout(row wrap)
              v-flex(xs12 :md3="windowInnerWidth > 1265 && windowInnerWidth < 1750" :md4="windowInnerWidth > 1750" :lg3="windowInnerWidth > 1265 && windowInnerWidth < 1750" :lg4="windowInnerWidth > 1750")
              v-flex.container-sucessfull(xs12 md12 lg12)
                v-layout(row wrap)
                  v-flex(xs12 md12 lg12)
                    img(:src="iconShieldSuccessfull")
                    h1.omnesMedium {{ (onlyPayment) ? 'Pago de cuotas exitoso' : 'Pago y afiliación exitosos' }}
                v-layout.info-creditcard(wrap row)
                  v-flex(xs12 md12 lg12)
                    v-card.successfull-card
                      v-layout(wrap row)
                        p.omnesMedium.subtitle(style="width: 100%; text-align: center; font-size: 20px; font-style: normal; font-weight: normal; font-size: 18px;") Medio de pago:
                      v-flex.success-info-title(xs12 md12 lg12)
                        p.omnesRegular.to-center {{ `${paymentsInfo.paymentResponse.brand.toString().toUpperCase()} &nbsp;&nbsp;${paymentsInfo.paymentResponse.cardNumber}` }}
                      v-flex.success-info-data(xs12 md12 lg12)
                        p.omnesMedium.to-center {{ `Por el monto total: &nbsp;&nbsp;${paymentsInfo.paymentResponse.coinSymbol}${paymentsInfo.paymentTotal}` }}
                v-layout.detail-content(row wrap style="margin-top: 15px; ")
                  v-flex.success-info-title(xs3 md lg3)
                    p.omnesRegularDetail.to-left Cliente:
                  v-flex.success-info-title(xs9 md9 lg9)
                    p.omnesRegularDetail.to-right {{ basicInfo.nombres.split(' ')[0] + ' ' + basicInfo.apellidoPaterno + ' ' + basicInfo.apellidoMaterno }}
                v-layout.detail-content(row wrap)
                  v-flex.success-info-title(xs6 md6 lg6)
                    p.omnesRegularDetail.to-left Fecha de transacción:
                  v-flex.success-info-title(xs6 md6 lg6)
                    p.omnesRegularDetail.to-right {{ paymentsInfo.date }}
                v-layout.detail-content(row wrap)
                  v-flex.success-info-title(xs6 md6 lg6)
                    p.omnesRegularDetail.to-left Hora de transacción:
                  v-flex.success-info-title(xs6 md6 lg6)
                    p.omnesRegularDetail.to-right {{ paymentsInfo.time }}
                .horizontal-line
                v-layout.detail-content(row wrap style="margin-top: 15px; ")
                  v-flex.success-info-title(xs12 md12 lg12)
                    p.omnesBoldDetail.to-left Datos de tu seguro:
                  v-flex.success-info-title(xs12 md12 lg12)
                    p.omnesRegularDetail.to-left {{ `N° de poliza: &nbsp;&nbsp;${paymentsInfo.polizaSeleccionada.policyNumber}` }}
                .horizontal-line
                v-layout.detail-content(row wrap
                  v-for="(cuota, index) in paymentsInfo.polizaSeleccionada.cuotas.filter(x => x.selected)"
                  :key="'quote-detail-'+index"
                  :style="(index===0)?'margin-top: 15px; ':''"
                )
                  v-flex.success-info-title(xs12 md12 lg12)
                    p.omnesBoldDetail.to-left {{ `Cuota &nbsp;&nbsp;${cuota.mes}` }}
                  v-flex.success-info-title(xs12 md12 lg12)
                    p.omnesRegularDetail.to-left {{ `Monto : &nbsp;&nbsp;${paymentsInfo.paymentResponse.coinSymbol} &nbsp;${cuota.monto.toFixed(2)}` }}
                .horizontal-line(style="margin-top: 10px; ")
                p.parraf-response.omnesRegular.to-center Se enviará a tu correo &nbsp;
                  strong {{basicInfo.correo}} &nbsp;
                  br
                  | una copia de tu pago.
                v-card#form-response-medium(style="box-shadow:none")
                  v-card-text
                    v-layout(wrap row)
                      v-flex(sm12 md12 lg12)
                        span
                          p.link.omnesRegular.to-center(@click="showSendEmail()") Deseo enviar a otro correo mi copia de pago &nbsp; <img :src="iconMensajeria" alt="alt-mail">
                v-flex(xs12 md12 lg12 v-if="!onlyPayment" style="text-align: center; padding-top: 20px;")
                  a.omnesMedium(href="#" @click="goHome('event-thank-you-page-analytic')") Volver al inicio
                .update-payment-actions(v-if="onlyPayment" style="width:100%; background-color: #E5E5E5; margin-top: 30px;")
                  v-layout
                    v-flex.text-xs-center.affiliation-only
                      figure
                        img(:src="creditCars")
                        p ¡Afilia un <strong>medio de pago automático</strong> y mantente al días en tus cuotas!
                  v-flex.text-affiliation
                    p Ahora puedes afililar una tarjeta de crédito o débito para que tus cuotas se paguen de forma automática a través de un cargo recurrente.
                  v-layout(style="margin-top: -25px;")
                    v-flex.text-xs-center
                      v-btn.omnesMedium(color="dark" @click="goToPayment()") Afiliar un medio de pago automático
                  v-flex(xs12 md12 lg12 style="text-align: center; padding-bottom: 20px;")
                    a.omnesMedium(href="#" @click="goHome('event-thank-you-page-analytic')") Volver al inicio
              v-flex(xs12 :md3="windowInnerWidth > 1265 && windowInnerWidth < 1750" :md4="windowInnerWidth > 1750" :lg3="windowInnerWidth > 1265 && windowInnerWidth < 1750" :lg4="windowInnerWidth > 1750")
          v-flex(xs12 md2 lg2)
    .inicio-extra
      section
        figure.d-flex.align-center.justify-center(style="margin-top:40px; ")
          img(src="../assets/payments/extra-mis-pagos.svg")
    //- [TERMINOS Y CONDICIONES]
    v-dialog(v-model="dialogTerms" max-width="800px")
      v-card#dialogTermsCard
        v-card-text
          v-layout(wrap)
            v-flex.wrapper-btn-close(xs12 md12 lg12)
              div(style="cursor: pointer; position: absolute; top: 15px; right: 15px; z-index: 99;")
                img(:src="iconBtnClose" alt="iconBtnClose" @click="dialogTerms = false" style="width: 30px;")
            v-flex.wrapper-title(xs12 md12 lg12)
              v-layout(wrap style="margin-top: 20px;")
                h3 Términos y condiciones
                p
                  |
                p(v-for="line of termsConditions")
                  | {{ line }}
    //- [INITIAL-DIALOG]
    v-dialog(v-model="showImportant" max-width="400px" :persistent="true")
      v-card#info-cvc
        v-card-title
          v-layout(wrap)
            v-flex.text-xs-center
              img(:src='icons.informacion' width="150px" style="align-self: center;")
          v-flex
            h2.omnesMedium.text-xs-center(style="color: #0855c4; font-size: 22px;") Información importante
        v-card-text
          v-layout
            v-flex(xs12 md12 lg12)
              v-layout.ly-item-step(wrap)
                v-flex.info-step-text(xs12 md12 lg12)
                  p En caso de tener un préstamo, el monto incluye la cuota más los intereses
          v-card-actions
            v-layout
              v-flex.text-xs-center
                v-btn.omnesMedium(color="dark" @click="showImportant=!showImportant") Entendido
    //- [SECOND-DIALOG]
    v-dialog(v-model="dialogCardIndications" max-width="480px" :persistent="true")
      v-card#info-cvc
        v-card-title
          v-flex
            h1.omnesMedium.text-xs-center Antes de pagar no olvides:
        v-card-text
          v-layout(wrap v-for="(item, index) in popUpIndications" :key="index")
            v-flex
              v-layout.item-step
                v-flex.info-step-icon
                  img(:src="item.icon" style="margin-top: 10px;")
                v-flex(style="margin-left: 15px;text-align: justify;")
                  p(v-html="item.text")
          v-card-actions
            v-layout
              v-flex.text-xs-center
                v-btn.omnesSemibold(color="dark" @click="dialogCardIndications = false") Continuar
    //- LOADER PROCESS
    v-dialog(v-model="loader" persistent width="300")
      v-card(color="primary" dark="")
        v-card-text
          | Corroborando y obteniendo información...
          v-progress-linear.mb-0(indeterminate="" color="white")
    //- 2do LOADER PROCESS
    v-dialog(v-model="loader2" persistent width="300")
      v-card(color="primary" dark="")
        v-card-text
          | {{ txtLoader2 }}
          v-progress-linear.mb-0(indeterminate="" color="white")
    //- MODAL EMAIL SEND
    v-dialog(v-model="dialogSendConstancy" max-width="430px" :persistent="true")
      v-card
        v-layout#dialog-formalities.dialog-with-inputbox
          v-flex(xs1 sm1 md1 lg1)
          v-flex.text-xs-center.text-md-center(xs10 sm10 md10 lg10)
            img.imgbtn-icon_close(:src="images.iconClose" @click="dialogSendConstancy = !dialogSendConstancy")
            img.img-send_constancy(:src="images.sendConstancy")
            h3 Recibe tu solicitud al correo:
            v-text-field(v-model='email_send_constancy' label="Correo electrónico" @input="emailConstErrors()")
              template(v-slot:prepend-inner='')
                img(:src="images.iconPencil")
            p.text-email_address(style="color: red; font-size: 13px; margin-top: -15px; margin-bottom: 20px;" v-if="errorEmail.length > 0") {{ errorEmail[0] }}
            v-btn#btnSendConstancy.omnesSemibold.btn-pink(type='button' @click="makeSendEmail" :disabled="errorEmail.length > 0") Enviar
          v-flex(xs1 sm1 md1 lg1)
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Niubiz from '@/components/payment/Niubiz'
import PaymentTermsConditions from '@/components/payment/PaymentTermsConditions'
import paymentErrors from './../interfaces/paymentErrors'
import paymentTerms from './../interfaces/paymentsTerms'
import Amplitude from './../interfaces/amplitudeData'
import Rules from './../interfaces/transactsRestrictions'
import PagoEfectivo from './../components/payment/pago-efectivo/PagoEfectivo.vue'
import PagoEfectivoPopupDetalle from './../components/payment/pago-efectivo/PagoEfectivoPopupDetalle.vue'
import CodigoPago from '../components/payment/pago-efectivo/CodigoPago.vue'
import ActualizarDatos from '../components/payment/pago-efectivo/ActualizarDatos.vue'
import Links from '../interfaces/links'
import Functionalities from '../interfaces/functionalities'

const KEY_BACK_RETURN = 'backReturn'
const IP_ADDR = 'ipaddress'
const KEY_BACK_HOME = 'backHome'
const KEY_PAYMENT_SUCCESS = 'paymentSuccess'
const KEY_CVC_SUCCESS = 'cvcSuccess'
const KEY_PAYMENT_RETRIES = 'paymentRetries'
const KEY_CVC_RETRIES = 'cvcRetries'
const VALUE_YES = '1'
// const VALUE_IN_TRANSACT = '2'
const VALUE_NO = '0'
const RECURRENT_AFFILIATION = 'recurrentAffiliation'
const REGEX_CARDS = [
  {re: '^4[0-9]{5}$', value: 'visa'},
  {re: '^5[1-5][0-9]{4}$', value: 'mastercard'},
  {re: '^3[47][0-9]{4}$', value: 'amex'},
  {re: '^3(?:0[0-5]|[68][0-9])[0-9]{3}$', value: 'dinners'}
]

export default {
  data () {
    return {
      links: Links,
      affiliation: false,
      allPolicies: [],
      polizasAvailable: [],
      loader: false,
      loader2: false,
      txtLoader2: '',
      dialogCVC: false,
      dialogCardAdmited: false,
      dialogSendConstancy: false,
      showFloatingBtn: false,
      showImportant: false,
      withPrestamo: false,
      dialogEnviarConstancia: false,
      dialogTerms: false,
      email_send_constancy: '',
      sectionSelectPolicy: true,
      sectionSelectQuotes: false,
      sectionVerifyData: false,
      sectionEnterDataPayment: false,
      sectionSuccessfullChangePayment: false,
      sectionThankPayment: false,
      productSelected: 0,
      disabledButton: true,
      windowInnerWidth: 0,
      dialogCardIndications: false,
      popUpIndications: [
        {
          icon: require('./../assets/cambio-cobro/icon-shield.svg'),
          text: 'Activar la <strong>compra online</strong> en tu tarjeta de débito o crédito.'
        },
        {
          icon: require('./../assets/cambio-cobro/icon-card-reload.svg'),
          text: 'Revisar los <strong>límites de compra y saldo</strong> de tu tarjeta.'
        },
        {
          icon: require('./../assets/cambio-cobro/icon-eye.svg'),
          text: 'Si eres cliente del <strong>BBVA</strong>, recuerda que debes obtener el código CVV desde el app de tu banco.'
        }
      ],
      images: {
        sendConstancy: require('./../assets/general/email-icon.svg'),
        iconClose: require('./../assets/formpp/icon_close.svg'),
        iconPencil: require('./../assets/formpp/icon_pencil.svg')
      },
      icons: {
        informacion: require('@/assets/characters/informa.svg'),
        oops: require('@/assets/characters/oops.svg'),
        error: require('@/assets/characters/sorprendido.svg')
      },
      iconBtnClose: require('./../assets/cambio-cobro/btn-close.svg'),
      iconPencil: require('./../assets/cambio-cobro/icon-pencil.svg'),
      creditCars: require('./../assets/cambio-cobro/credit-cards.png'),
      iconShieldSuccessfull: require('./../assets/cambio-cobro/icon-shield-successfull.svg'),
      iconMensajeria: require('./../assets/cambio-cobro/icon-enviar-mail.svg'),
      iconSeguridad: require('./../assets/cambio-cobro/icon-seguridad.svg'),
      niubiz: {
        configuration: {
          sessionkey: '',
          channel: 'paycard',
          merchantid: '',
          purchasenumber: '', // Poliza
          amount: 0, // El precio a cobrar
          callbackurl: process.env.LANDING_PAYMENT_URL + 'payments/tokens?protocol=' + process.env.LANDING_PROTOCOL + '&host=' + process.env.LANDING_HOST + '/zona-segura&path=/pago-de-cuotas',
          language: 'es',
          font: 'https://fonts.googleapis.com/css?family=Montserrat:400&display=swap',
          recurrentmaxamount: 0 // Máx. pago
        },
        styles: {
          base: {
            color: '#495057',
            fontWeight: 600,
            fontFamily: '"Omnes Regular", sans-serif',
            fontSize: '16px',
            fontSmoothing: 'antialiased',
            placeholder: {
              color: '#c4c4c4'
            },
            autofill: {
              color: '#e39f48'
            }
          },
          invalid: {
            color: '#dc3545',
            '::placeholder': { color: '#FFCCA5' }
          }
        },
        pagador: {
          name: '',
          lastName: ' ',
          email: '',
          alias: '',
          userBlockId: ''
        },
        dataSession: {
          apiKey: '',
          currency: '',
          amount: 1,
          clientIP: '192.168.0.1',
          merchantDefineData: {}
        },
        finishGetSessionKey: false,
        vuetify: true,
        checkRecurrent: true,
        checkAccept: false,
        botonTexto: 'Pagar',
        buttonCurrency: 'S/',
        buttonAmount: '1'
      },
      paymentResponse: {},
      cardTypes: ['visa', 'mastercard', 'amex', 'american express', 'dinners'],
      productsIcons: {
        'educacion_garantizada': require('@/assets/products/educacion-garantizada.svg'),
        'vida': require('@/assets/products/vida.svg'),
        'masivos': require('@/assets/products/seguro-vehicular.svg'),
        'seguro_vehicular': require('@/assets/products/seguro-vehicular.svg'),
        'seguro_vehicular_modular': require('@/assets/products/seguro-vehicular.svg')
      },
      polizasDisponibles: [],
      polizaSeleccionada: {},
      paymentTotal: 0,
      termsConditions: [],
      errorEmail: [],
      pdcPayments: true,
      pdcHistory: false,
      pagoEfectivoDetalle: false,
      medioDePago: 0,
      popupCodigoDetalle: false,
      btnPagoEfectivo: true,
      codigoPagoEfectivo: '000000',
      correoPagoEfectivo: '',
      switchActualizarDatos: false,
      switchPagoEfectivo: false
    }
  },
  watch: {
    productSelected: function (val) {
      if (val < 1) {
        this.disabledButton = true
      } else {
        this.disabledButton = false
      }
    }
  },
  methods: {
    ...mapActions('user', ['getPolizasVidaVehicular', 'getSessionKey']),
    ...mapActions('utilities', ['getDatetime']),
    ...mapActions('payments', ['getPaymentQuotes', 'paymentQuotes', 'pagoEfectivo', 'sendMail']),
    ...mapActions('event', ['eventLog']),
    accept () {
      this.dialogCVC = false
    },
    emailConstErrors () {
      const errors = []
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!re.test(this.email_send_constancy)) {
        errors.push('El email debe ser válido.')
      }
      if (!this.email_send_constancy) {
        errors.push('Rellenar campo obligatorio.')
      }
      this.errorEmail = errors
    },
    showSendEmail () {
      this.dialogSendConstancy = true
      this.email_send_constancy = this.basicInfo.correo

      // #004.44: Elemento - página gracias - Seleccionar Botón
      this.$gtm.trackEvent({
        'event': 'virtualEvent',
        'category': 'Zona Segura',
        'action': 'Mis pagos - Pago exitoso',
        'label': `${this.paymentsInfo.polizaSeleccionada.name} - Seleccionar Botón - Deseo enviar a otro correo mi copia de pago`
      })

      this.$gtm.trackEvent({
        'event': 'select_button',
        'Nombre Sección': 'Zona Segura',
        'TipoElemento': 'Botón',
        'TipoAccion': 'Mis pagos - Pago exitoso',
        'CTA': `${this.paymentsInfo.polizaSeleccionada.name} - Seleccionar Botón - Deseo enviar a otro correo mi copia de pago`
      })
    },
    generateTableQuotes (cuotas, coinSymbol) {
      let quotes = ''
      for (let cuota of cuotas.filter(x => x.selected)) {
        quotes += `<tr>
          <td style="border-radius: 10px 0px 0px 0px; background: #EDF4FC; padding-left: 30px;"><span style="font-size: 16px; color: #0855c4; font-family: Arial, Helvetica, sans-serif;">
            ${cuota.mes}
          </span></td>
          <td style="border-radius: 0px 10px 0px 0px; background: #EDF4FC; padding-right: 30px; text-align: right; height: 35px;"><span style="font-size: 16px; color: #0855c4; font-family: Arial, Helvetica, sans-serif;">
            ${coinSymbol} &nbsp;${cuota.monto.toFixed(2)}
          </span></td>
        </tr>`
      }
      return quotes
    },
    makeSendEmail () {
      this.loader = true
      let data = {
        nombre: this.basicInfo.nombres || ' ',
        correo: this.email_send_constancy,
        tarjeta: (this.paymentsInfo.paymentResponse.brand.toString().toUpperCase() + ' ' + this.paymentsInfo.paymentResponse.cardNumber) || ' ',
        poliza: this.paymentsInfo.subscription.subscription.objectId || '',
        producto: this.paymentsInfo.polizaSeleccionada.name || '',
        cuotas: this.generateTableQuotes(this.paymentsInfo.polizaSeleccionada.cuotas, this.paymentsInfo.paymentResponse.coinSymbol) || '',
        affiliation: this.paymentsInfo.subscribe || false,
        prestamos: this.paymentsInfo.prestamos || false
      }
      localStorage.setItem(KEY_PAYMENT_SUCCESS, VALUE_NO)
      this.sendMail(data)
        .then((res) => {
          this.loader = false
          if (res.status === 200 && res.data.includes('OK')) {
            // this.dialogEnviadoConstancia = true
            this.$swal({
              title: 'Estimado cliente',
              text: 'Te enviamos la constancia a tu correo.',
              confirmButtonText: 'Ok'
            }).then((result) => {
              // this.trackEvents.mailingSuccess.producto = this.polizaSeleccionada.name
              // this.$gtm.trackEvent(this.trackEvents.mailingSuccess)
              this.dialogSendConstancy = false
            })
          } else {
            // this.trackEvents.mailingError.producto = products
            // this.$gtm.trackEvent(this.trackEvents.mailingError)
            this.$swal({
              imageUrl: this.icons.oops,
              title: '¡Oops, algo salió mal!',
              html: 'Inténtalo más tarde o comunícate <a href="' + this.links.WhatsApp + '" target="_blank" class="omnesMedium">aquí</a>.',
              confirmButtonText: 'Ok'
            }).then(() => {
              this.$router.push('/inicio')
            })
          }
        })
        .catch(() => {
          this.loader = false
          // this.trackEvents.mailingError.producto = products
          // this.$gtm.trackEvent(this.trackEvents.mailingError)
          this.$swal({
            imageUrl: this.icons.oops,
            title: '¡Oops, algo salió mal!',
            html: 'Inténtalo más tarde o comunícate <a href="' + this.links.WhatsApp + '" target="_blank" class="omnesMedium">aquí</a>.',
            confirmButtonText: 'Ok'
          }).then(() => {
            this.$router.push('/inicio')
          })
        })
    },
    closeDialogMethodPayment () {
      this.$router.go(0)
    },
    getStatusCuota (cuota) {
      return (cuota.tipo.toLowerCase() === 'vencida') ? 'cuota-vencida' : 'cuota-disponible'
    },
    goToSelectQuotes (poliza, step) {
      this.polizaSeleccionada = poliza
      if ((poliza.oriProducto || '').toString().toLowerCase().includes('vehicular')) {
        this.termsConditions = paymentTerms.vehicular
      } else {
        this.termsConditions = paymentTerms.vida
      }
      // METODO SE INVOCA 3 VECES PARA DIFERENTES PASOS
      // eslint-disable-next-line eqeqeq
      if (step == 1) {
        // EVENT TRACK - Universal Analytics
        this.$gtm.trackEvent({
          event: 'virtualEvent',
          category: 'Zona Segura',
          action: 'Mis pagos - Pagar seguro - Paso 1',
          label: 'Seleccionar seguro - ' + poliza.oriProducto
        })
        // EVENT TRACK - GA4
        this.$gtm.trackEvent({
          event: 'select_button',
          'Nombre Sección': 'Zona Segura',
          TipoElemento: 'Botón',
          TipoAccion: 'Mis pagos - Pagar seguro - Paso 1',
          CTA: 'Seleccionar seguro - ' + poliza.oriProducto
        })
      // eslint-disable-next-line eqeqeq
      } else if (step == 'back') {
        // EVENT TRACK - Universal Analytics
        this.$gtm.trackEvent({
          event: 'virtualEvent',
          category: 'Zona Segura',
          action: 'Mis pagos - Pagar seguro - Paso 2',
          label: this.polizaSeleccionada.oriProducto + ' - Seleccionar Botón - Volver'
        })
        // EVENT TRACK - GA4
        this.$gtm.trackEvent({
          event: 'select_button',
          'Nombre Sección': 'Zona Segura',
          TipoElemento: 'Botón',
          TipoAccion: 'Mis pagos - Pagar seguro - Paso 2',
          CTA: this.polizaSeleccionada.oriProducto + ' - Seleccionar Botón - Volver'
        })
      }
      let eventProperties = {}
      eventProperties[Amplitude.PaymentQuotes.properties.producto] = poliza.ramo
      eventProperties[Amplitude.PaymentQuotes.properties.subproducto] = poliza.oriProducto
      eventProperties[Amplitude.PaymentQuotes.properties.poliza] = poliza.policyNumber
      eventProperties[Amplitude.PaymentQuotes.properties.estado] = (poliza.pendingQuotes > 0) ? 'moroso' : 'saldado'
      this.$amplitude.getInstance().logEvent(Amplitude.PaymentQuotes.events.intencion, eventProperties)

      this.sectionEnterDataPayment = false
      this.sectionSelectPolicy = false
      this.sectionSelectQuotes = true
      this.sectionVerifyData = false
      this.sectionSuccessfullChangePayment = false
      this.sectionThankPayment = false
      for (let item of this.polizasDisponibles) {
        item.selected = false
        if (item.policyNumber === poliza.policyNumber) {
          item.selected = true
          for (let x = 0; x < item.cuotas.length; x++) {
            item.cuotas[x].selected = false
          }
          if (item.info && item.info !== null) {
            let total = 0
            for (let cuota of this.polizaSeleccionada.cuotas) {
              if (cuota.selected) {
                total += parseFloat(cuota.monto)
              }
            }
            this.pdcPayments = true
            this.paymentTotal = parseFloat(total).toFixed(2)
          } else {
            this.pdcPayments = false
          }
          this.pdcHistory = !!item.historial.length
        }
      }
    },
    goToVerifyData () {
      const self = this
      this.switchPagoEfectivo = (
        (this.polizaSeleccionada.oriProducto !== 'VIDA CON DEVOLUCION' && this.polizaSeleccionada.ramo === 'Vida') &&
        (['CAJA_VENTANILLA', 'TODOS', ''].includes(this.polizaSeleccionada.viaDeCobro) || !this.polizaSeleccionada.viaDeCobro)
      ) || (this.polizaSeleccionada.flagPagoEfectivo && !this.polizaSeleccionada.oriProducto.toLowerCase().includes('vehicular'))

      const canPay = Functionalities.isAvailableSilent(Functionalities.vida.PAGO_CUOTAS, self.functionsRules, self)
      const canPayEfect = Functionalities.isAvailableSilent(Functionalities.vida.PAGO_EFECTIVO, self.functionsRules, self)
      if (!canPay && (!canPayEfect || (canPayEfect && !self.switchPagoEfectivo))) {
        Functionalities.isAvailable(Functionalities.vida.PAGO_CUOTAS, self.functionsRules, self)
        return
      }
      this.sectionEnterDataPayment = false
      this.sectionSelectPolicy = false
      this.sectionSelectQuotes = false
      this.sectionSuccessfullChangePayment = false
      this.sectionThankPayment = false
      this.sectionVerifyData = true

      // EVENT TRACK - Universal Analytics
      this.$gtm.trackEvent({
        event: 'virtualEvent',
        category: 'Zona Segura',
        action: 'Mis pagos - Pagar seguro - Paso 1',
        label: this.polizaSeleccionada.name + ' - Seleccionar Botón - Continuar'
      })
      // EVENT TRACK - GA4
      this.$gtm.trackEvent({
        event: 'select_button',
        'Nombre Sección': 'Zona Segura',
        TipoElemento: 'Botón',
        TipoAccion: 'Mis pagos - Pagar seguro - Paso 1',
        CTA: this.polizaSeleccionada.name + ' - Seleccionar Botón - Continuar'
      })

      let cuotas = []
      let cantidad = 0
      let total = 0
      let eventProperties = {}

      for (let cuota of this.polizaSeleccionada.cuotas) {
        if (cuota.selected) {
          cuotas.push(cuota.mes)
          cantidad++
          total += parseFloat(cuota.monto)
        }
      }

      eventProperties[Amplitude.PaymentQuotes.properties.producto] = this.polizaSeleccionada.ramo
      eventProperties[Amplitude.PaymentQuotes.properties.subproducto] = this.polizaSeleccionada.oriProducto
      eventProperties[Amplitude.PaymentQuotes.properties.poliza] = this.polizaSeleccionada.policyNumber
      eventProperties[Amplitude.PaymentQuotes.properties.cantidad] = cantidad
      eventProperties[Amplitude.PaymentQuotes.properties.cuotas] = cuotas
      eventProperties[Amplitude.PaymentQuotes.properties.monto] = this.polizaSeleccionada.info.pago.moneda + ' ' + total.toFixed(2)
      eventProperties[Amplitude.PaymentQuotes.properties.frecuenciaPago] = this.polizaSeleccionada.info.pago.frecuencia
      this.$amplitude.getInstance().logEvent(Amplitude.PaymentQuotes.events.resumen, eventProperties)
    },
    getPagoEfectivo () {
      const self = this
      self.txtLoader2 = 'Espere mientras generamos su código'
      self.loader2 = true
      const date = new Date()
      date.setDate(date.getDate() + 1)
      const cuotas = []
      for (let item of self.polizaSeleccionada.cuotas) {
        if (item.selected) {
          let cuotasAux = self.polizaSeleccionada.info.pago.cuotas.filter(c => c.mes === item.mes)
          cuotas.push(...cuotasAux)
        }
      }
      const openItems = cuotas.map(c => c.oi).join(',')

      const trazabilidad = {
        codigoAgente: self.polizaSeleccionada.info.codigoAgente,
        codigoAgencia: self.polizaSeleccionada.info.codigoAgencia,
        numeroPoliza: self.polizaSeleccionada.policyNumber,
        apellidoPaterno: self.polizaSeleccionada.info.cliente.apellidoPaterno,
        apellidoMaterno: self.polizaSeleccionada.info.cliente.apellidoMaterno,
        nombres: self.polizaSeleccionada.info.cliente.nombre,
        tipoDocumento: self.polizaSeleccionada.info.cliente.tipoDocumento,
        numeroDocumento: self.polizaSeleccionada.info.cliente.documentoIdentidad,
        frecuenciaPago: self.polizaSeleccionada.info.pago.frecuencia,
        producto: self.polizaSeleccionada.info.producto,
        periodo: self.polizaSeleccionada.info.periodo,
        montoPendiente: '0',
        montoFuturo: '0',
        moneda: self.polizaSeleccionada.info.pago.moneda,
        estadoEnviado: '2',
        mensaje: '',
        nombreAgente: self.polizaSeleccionada.info.nombreAgente,
        montoPagado: self.paymentTotal,
        fechaPagado: date.toLocaleString('pt-PT', { timeZone: 'America/Lima' }).replace(',', ''), // '20/08/2021 15:42:21'
        indPlanillaAso: ''
      }
      const link = {
        xApiKey: self.niubiz.dataSession.apiKey,
        // aplicacion: "ZonaSegura",
        // bloquearEnvio: true,
        cliente: {
          tipoDocumento: self.polizaSeleccionada.info.cliente.tipoDocumento,
          documentoIdentidad: self.polizaSeleccionada.info.cliente.documentoIdentidad,
          nombre: self.polizaSeleccionada.info.cliente.nombre,
          apellidoPaterno: self.polizaSeleccionada.info.cliente.apellidoPaterno || '-',
          apellidoMaterno: self.polizaSeleccionada.info.cliente.apellidoMaterno || '-',
          email: self.basicInfo.correo || self.polizaSeleccionada.info.cliente.email,
          celular: self.basicInfo.celular || self.polizaSeleccionada.info.cliente.celular,
          departamento: self.polizaSeleccionada.info.cliente.departamento,
          provincia: self.polizaSeleccionada.info.cliente.provincia,
          distrito: self.polizaSeleccionada.info.cliente.distrito
        },
        codigoEnvio: '',
        // enviarSMS: false,
        // expiracion: 24,
        identificador: self.polizaSeleccionada.policyNumber,
        poliza: self.polizaSeleccionada.policyNumber,
        pago: {
          cuotas: [],
          frecuencia: self.polizaSeleccionada.info.pago.frecuencia,
          moneda: self.polizaSeleccionada.info.pago.moneda,
          monedaSimbolo: self.polizaSeleccionada.monedaSimbolo,
          monto: self.polizaSeleccionada.info.pago.monto
        },
        producto: self.polizaSeleccionada.info.producto,
        productoAcsele: self.polizaSeleccionada.info.productoAcsele
      }
      const request = {
        xApiKey: self.niubiz.dataSession.apiKey,
        trazabilidad: trazabilidad,
        link: link,
        order: {
          description: 'Pago de cuotas - Póliza N° ' + self.polizaSeleccionada.policyNumber,
          amount: parseFloat(self.paymentTotal),
          currency: self.polizaSeleccionada.info.pago.moneda,
          expirationDate: date.toLocaleString('pt-PT', { timeZone: 'America/Lima' }).replace(', ', 'T') + '-0500',
          metadata: {
            pagoefectivo: {
              numeropoliza: self.polizaSeleccionada.policyNumber,
              numeropropuesta: '',
              idoperacion: openItems,
              numip: this.ipInfo || localStorage.setItem(IP_ADDR),
              moneda: self.polizaSeleccionada.info.pago.moneda,
              monto: parseFloat(self.paymentTotal).toFixed(2),
              tipopago: '6',
              codusuariocreador: '',
              cardbrand: 'PagoEfectivo'
            }
          }
        },

        customer: {
          email: process.env.ENVIRONMENT === 'prod' ? self.basicInfo.correo : 'pruebasqa.interseguro@gmail.com',
          documentType: self.basicInfo.tipoDocumento,
          documentNumber: self.basicInfo.numeroDocumento,
          country: 'PE',
          name: self.basicInfo.nombres,
          lastName: self.basicInfo.apellidoPaterno,
          motherLastName: self.basicInfo.apellidoMaterno,
          phone: self.basicInfo.celular,
          address: 'Peru PE',
          addressCity: 'Lima'
        }
      }
      self.pagoEfectivo(request).then(res => {
        if (res.data.code === '01') {
          // Muestro el resultado.
          this.codigoPagoEfectivo = res.data.data.paymentCode
          this.popupCodigoDetalle = true

          /*
            Estructura del resultado:
            { "code": "01", "title": "Message", "message": "SUCCESS",
            "data": { "orderId": "ord_test_ds43zbLpc5i2MGil","objectId": "CASH_PAYMENT", "providerId": "CULQI",
                "description": "OrdendePrueba", "currency": "PEN", "amount": 1504.15, "paymentCode": "046478651", "orderNumber": "prueba222222w",
                "expirationDate": "25/07/2022", "creationDate": "14/07/2022", "status": "PENDING" }}
            //Estructura en caso de error
              {
                "code": "90",
                "title": "Error",
                "message": "El campo ‘order_number’ debe ser unico. ",
                "providerCode": "parameter_error",
                "providerMerchantMessage": "El campo ‘order_number’ debe ser unico. ",
                "providerUserMessage": "Hubo algunos problemas al intentar validar tu compra. Contáctanos para ayudarte."
              }
          */
        } else {
          // ERROR GENERICO
          self.$swal({
            imageUrl: this.icons.oops,
            title: '¡Parece que algo salió mal!',
            text: 'Te pedimos disculpas por el inconveniente. Por favor, inténtalo nuevamente en unos minutos.',
            confirmButtonText: 'Entendido'
          })
        }
        this.loader2 = false
      }).catch(err => {
        // ERROR GENERICO
        self.closeCodigoPago()
        self.eventLog({
          categoria: 'Funcionalidad',
          nombre: 'Pago Efectivo - Front Error',
          datos: {error: err, tipo: 'pago efectivo'}
        })
        self.$swal({
          imageUrl: this.icons.oops,
          title: '¡Parece que algo salió mal!',
          text: 'Te pedimos disculpas por el inconveniente. Por favor, inténtalo nuevamente en unos minutos.',
          confirmButtonText: 'Entendido'
        })
        this.loader2 = false
      })
    },
    goToConfirmChange () {
      let self = this
      localStorage.setItem(KEY_BACK_RETURN, VALUE_YES)
      // TRACK EVENT - AMPLITUDE
      /*
      this.$amplitude.getInstance()
        .logEvent(
          this.amplitude.events.intentionChangeCVC,
          {}
        )
      */
      // EVENT TRACK - Universal Analytics
      this.$gtm.trackEvent({
        event: 'virtualEvent',
        category: 'Zona Segura',
        action: 'Mis pagos - Pagar seguro - Paso 2',
        label: this.polizaSeleccionada.oriProducto + ' - Seleccionar Botón - Ir a pagar'
      })
      // EVENT TRACK - GA4
      this.$gtm.trackEvent({
        event: 'select_button',
        'Nombre Sección': 'Zona Segura',
        TipoElemento: 'Botón',
        TipoAccion: 'Mis pagos - Pagar seguro - Paso 2',
        CTA: this.polizaSeleccionada.oriProducto + ' - Seleccionar Botón - Ir a pagar'
      })

      self.showFloatingBtn = false
      // COMPLETANDO INFORMACIÓN DE POLIZA
      self.niubiz.configuration.purchasenumber = new Date().getTime() + ''
      self.niubiz.configuration.amount = parseFloat(self.paymentTotal)
      self.niubiz.configuration.recurrentmaxamount = parseFloat(self.polizaSeleccionada.info.pago.monto)
      self.niubiz.buttonCurrency = self.polizaSeleccionada.info.pago.moneda
      self.niubiz.buttonAmount = self.paymentTotal
      // COMPLETANDO INFORMACIÓN DE CLIENTE
      self.niubiz.pagador.name = self.removeAcents(self.basicInfo.nombres).slice(0, 24)
      self.niubiz.pagador.lastName = self.removeAcents((self.basicInfo.apellidoPaterno || '') + ' ' + (self.basicInfo.apellidoMaterno || '')).slice(0, 24)
      self.niubiz.pagador.email = self.basicInfo.correo
      self.niubiz.pagador.alias = self.removeAcents(self.basicInfo.nombres).slice(0, 24)
      self.niubiz.pagador.userBlockId = self.basicInfo.numeroDocumento
      // COMPLETANDO INFORMACIÓN DE PAGO
      self.niubiz.dataSession.currency = self.polizaSeleccionada.info.pago.moneda
      self.niubiz.dataSession.amount = parseFloat(self.paymentTotal)
      // - INFORMACION: http://mdd.evirtuales.com/ con código 6300
      self.niubiz.dataSession.merchantDefineData = {
        MDD1: self.basicInfo.celular,
        MDD2: self.basicInfo.correo,
        MDD3: self.polizaSeleccionada.policyNumber,
        MDD4: self.basicInfo.correo,
        MDD21: '1',
        MDD32: self.basicInfo.numeroDocumento,
        MDD34: self.basicInfo.numeroDocumento,
        MDD37: '1',
        MDD63: self.basicInfo.tipoDocumento,
        MDD70: '1',
        MDD75: 'Cliente',
        MDD77: '159'
      }
      // El comercio (merchant_id) lo resuelve el BFF al crear la sesión: ver loadNiubizSessionKey
      // CARGANDO INFO PARA EL FORM NIUBIZ PARA SER USADA NUEVAMENTE DESPUES DE LA RESPUESTA DEL PAYMENT-API
      self.getDatetime().then(res => {
        let currentDate = res.data.time
        let [date, time] = currentDate.split(' ')
        let [year, month, day] = date.split('-')
        let dateSlash = `${day}/${month}/${year}`
        const subscribeInfo = localStorage.getItem(RECURRENT_AFFILIATION) || '0'
        self.polizaSeleccionada.info.cliente.tipoDocumento = self.polizaSeleccionada.info.cliente.tipoDocumento.toString().toUpperCase()
        let trazabilidad = {
          codigoAgente: self.polizaSeleccionada.info.codigoAgente,
          codigoAgencia: self.polizaSeleccionada.info.codigoAgencia,
          numeroPoliza: self.polizaSeleccionada.policyNumber,
          apellidoPaterno: self.polizaSeleccionada.info.cliente.apellidoPaterno,
          apellidoMaterno: self.polizaSeleccionada.info.cliente.apellidoMaterno,
          nombres: self.polizaSeleccionada.info.cliente.nombre,
          tipoDocumento: self.polizaSeleccionada.info.cliente.tipoDocumento,
          numeroDocumento: self.polizaSeleccionada.info.cliente.documentoIdentidad,
          frecuenciaPago: self.polizaSeleccionada.info.pago.frecuencia,
          producto: self.polizaSeleccionada.info.producto,
          periodo: self.polizaSeleccionada.info.periodo,
          montoPendiente: '0',
          montoFuturo: '0',
          moneda: self.polizaSeleccionada.info.pago.moneda,
          estadoEnviado: '2',
          mensaje: '',
          nombreAgente: self.polizaSeleccionada.info.nombreAgente,
          montoPagado: self.paymentTotal,
          fechaPagado: dateSlash + ' ' + time, // '20/08/2021 15:42:21'
          indPlanillaAso: ''
        }

        let link = {
          xApiKey: self.niubiz.dataSession.apiKey,
          // aplicacion: "ZonaSegura",
          // bloquearEnvio: true,
          cliente: {
            tipoDocumento: self.polizaSeleccionada.info.cliente.tipoDocumento,
            documentoIdentidad: self.polizaSeleccionada.info.cliente.documentoIdentidad,
            nombre: self.polizaSeleccionada.info.cliente.nombre,
            apellidoPaterno: self.polizaSeleccionada.info.cliente.apellidoPaterno || '-',
            apellidoMaterno: self.polizaSeleccionada.info.cliente.apellidoMaterno || '-',
            email: self.basicInfo.correo || self.polizaSeleccionada.info.cliente.email,
            celular: self.basicInfo.celular || self.polizaSeleccionada.info.cliente.celular,
            departamento: self.polizaSeleccionada.info.cliente.departamento,
            provincia: self.polizaSeleccionada.info.cliente.provincia,
            distrito: self.polizaSeleccionada.info.cliente.distrito
          },
          codigoEnvio: '',
          // enviarSMS: false,
          // expiracion: 24,
          identificador: self.polizaSeleccionada.policyNumber,
          poliza: self.polizaSeleccionada.policyNumber,
          pago: {
            cuotas: [],
            frecuencia: self.polizaSeleccionada.info.pago.frecuencia,
            moneda: self.polizaSeleccionada.info.pago.moneda,
            monedaSimbolo: self.polizaSeleccionada.monedaSimbolo,
            monto: self.polizaSeleccionada.info.pago.monto
          },
          producto: self.polizaSeleccionada.info.producto,
          productoAcsele: self.polizaSeleccionada.info.productoAcsele
        }
        let transaccion = {
          documento: self.basicInfo.numeroDocumento,
          poliza: self.polizaSeleccionada.policyNumber,
          transaccion: {
            action: (subscribeInfo === '1') ? 'PAGAR Y AFILIAR' : 'PAGAR',
            amount: self.paymentTotal,
            date: currentDate,
            openItems: [],
            cardbrand: '',
            paycard: '',
            transactionID: '',
            subscriptionId: '',
            providerId: '',
            purchaseNumber: self.polizaSeleccionada.policyNumber,
            status: 'ACEPTADO'
          }
        }
        self.email_send_constancy = self.basicInfo.correo
        let subscription = {
          token: '',
          amount: parseFloat(self.polizaSeleccionada.info.pago.monto),
          currency: self.polizaSeleccionada.info.pago.moneda,
          customer: {
            email: self.basicInfo.correo,
            documentType: self.basicInfo.tipoDocumento,
            documentNumber: self.basicInfo.numeroDocumento,
            country: 'PE',
            name: self.basicInfo.nombres,
            lastName: self.basicInfo.apellidoPaterno,
            motherLastName: self.basicInfo.apellidoMaterno,
            phone: self.basicInfo.celular,
            address: 'Peru PE',
            addressCity: 'Lima',
            metadata: {}
          },
          subscription: {
            objectId: self.polizaSeleccionada.policyNumber,
            currency: self.polizaSeleccionada.info.pago.moneda,
            productName: self.polizaSeleccionada.info.productoAcsele,
            amount: parseFloat(self.polizaSeleccionada.info.pago.monto),
            frecuency: self.polizaSeleccionada.info.pago.frecuencia,
            metadata: {
              numeroPoliza: self.polizaSeleccionada.policyNumber
            },
            metadataAffiliation: {
              cliente: {
                apellidopaterno: self.basicInfo.apellidoPaterno,
                apellidomaterno: self.basicInfo.apellidoMaterno,
                documentoidentidad: self.basicInfo.numeroDocumento,
                nombre: self.basicInfo.nombres,
                tipodocumento: self.basicInfo.tipoDocumento === 'DNI' ? 1 : 2
              },
              afiliacion: {
                fechaingresomandato: currentDate,
                moneda: self.polizaSeleccionada.info.pago.moneda,
                numeropropuesta: '',
                numeropoliza: self.polizaSeleccionada.policyNumber,
                periodopago: self.polizaSeleccionada.info.pago.frecuencia.toUpperCase(),
                tipooperacion: 1,
                codusuariocreador: '',
                fechaOperacion: currentDate,
                datoadicional: ''
              },
              tarjeta: {
                fechavencimientocadena: '',
                moneda: self.polizaSeleccionada.info.pago.moneda,
                numerotarjeta: '',
                numerocuenta: '',
                tipocuenta: 0,
                tipoviacobro: 2,
                viacobro: 8
              },
              tarjeta_pp: {
                fechavencimiento: '',
                moneda: self.polizaSeleccionada.info.pago.moneda,
                numerotarjeta: '',
                numerocuenta: '',
                tipocuenta: 0,
                tipoviacobro: 2,
                viacobro: 8
              }
            },
            metadataDigitalPayment: {
              pagodigital: {
                numeropropuesta: '',
                numeropoliza: self.polizaSeleccionada.policyNumber,
                idoperacion: '',
                moneda: self.polizaSeleccionada.info.pago.moneda,
                monto: self.paymentTotal,
                fechapago: currentDate,
                tipopago: '2',
                codusuariocreador: '',
                numip: self.niubiz.dataSession.clientIP
              }
            }
          }
        }

        let hash = {trazabilidad, link, transaccion, subscription, date: date, time: time, paymentTotal: self.paymentTotal}
        hash.xApiKey = self.niubiz.dataSession.apiKey
        hash.ip = self.niubiz.dataSession.clientIP
        // AGREGANDO LOS SUBS DEPENDIENDO DE LA CANTIDAD DE POLIZAS ELEGIDAS
        for (let item of self.polizaSeleccionada.cuotas) {
          if (item.selected) {
            let cuotas = self.polizaSeleccionada.info.pago.cuotas.filter(c => c.mes === item.mes)
            hash.link.pago.cuotas.push(...cuotas)
          }
        }
        self.withPrestamo = hash.link.pago.cuotas.filter(c => (c.descConcepto || '').toLowerCase().includes('prestamo')).length > 0
        let openItems = hash.link.pago.cuotas.map(c => c.oi)
        hash.transaccion.openItems = openItems
        hash.prestamos = self.withPrestamo
        hash.subscription.subscription.metadataDigitalPayment.pagodigital.idoperacion = openItems.join(',')
        hash.polizaSeleccionada = self.polizaSeleccionada

        self.$store.commit('payments/setPayments', hash)

        self.niubiz.finishGetSessionKey = false
        self.niubiz.sessionkey = ''
        self.loader = true
        self.sectionSelectPolicy = false
        self.sectionSelectQuotes = false
        self.sectionEnterDataPayment = true
        self.sectionVerifyData = false
        self.sectionSuccessfullChangePayment = false
        self.sectionThankPayment = false
        setTimeout(function () {
          self.loadFormNiubiz()
        }, 1000)
      })
    },
    getCardBrand: function (bin) {
      const filter = REGEX_CARDS.find((brand) => new RegExp(brand.re).test(bin))
      let brand = filter.value || ''
      if (brand === '') {
        brand = bin
      }
      return brand
    },
    goHome (eventThankYouPageAnalytic = '') {
      // EVENT TRACK - Universal Analytics
      if (eventThankYouPageAnalytic === 'event-38-select-button-analytic') {
        this.$gtm.trackEvent({
          event: 'virtualEvent',
          category: 'Zona Segura',
          action: 'Mis pagos - Pagar seguro - Paso 1',
          label: this.polizaSeleccionada.name + ' - Seleccionar Botón - Volver'
        })
        // EVENT TRACK - GA4
        this.$gtm.trackEvent({
          event: 'select_button',
          'Nombre Sección': 'Zona Segura',
          TipoElemento: 'Botón',
          TipoAccion: 'Mis pagos - Pagar seguro - Paso 1',
          CTA: this.polizaSeleccionada.name + ' - Seleccionar Botón - Volver'
        })
      }

      // #004.44: Elemento - página gracias - Seleccionar Botón
      if (eventThankYouPageAnalytic === 'event-thank-you-page-analytic') {
        this.$gtm.trackEvent({
          'event': 'virtualEvent',
          'category': 'Zona Segura',
          'action': 'Mis pagos - Pago exitoso',
          'label': `${this.paymentsInfo.polizaSeleccionada.name} - Seleccionar Botón - Volver al inicio`
        })

        this.$gtm.trackEvent({
          'event': 'select_button',
          'Nombre Sección': 'Zona Segura',
          'TipoElemento': 'Botón',
          'TipoAccion': 'Mis pagos - Pago exitoso',
          'CTA': `${this.paymentsInfo.polizaSeleccionada.name} - Seleccionar Botón - Volver al inicio`
        })
      }

      localStorage.setItem(KEY_PAYMENT_SUCCESS, VALUE_NO)
      this.$router.push('/inicio')
    },
    removeAcents (cadena) {
      const acentos = {'%': '', 'á': 'a', 'é': 'e', 'í': 'i', 'ó': 'o', 'ú': 'u', 'Á': 'A', 'É': 'E', 'Í': 'I', 'Ó': 'O', 'Ú': 'U'}
      return cadena.split('').map(letra => acentos[letra] || letra).join('').toString()
    },
    enabledQuote (index) {
      if (index === 0) {
        return false
      } else {
        return !this.polizaSeleccionada.cuotas[index - 1].selected
      }
    },
    selectCuota (cuota, index) {
      let numeroCuotas
      cuota.selected = !cuota.selected
      if (cuota.selected) {
        numeroCuotas = index + 1
      } else {
        numeroCuotas = index
      }

      if (!cuota.selected) {
        for (let i = index + 1; i < this.polizaSeleccionada.cuotas.length; i++) {
          this.polizaSeleccionada.cuotas[i].selected = false
        }
      }
      let total = parseFloat(0)
      for (let cuota of this.polizaSeleccionada.cuotas) {
        if (cuota.selected) {
          total += parseFloat(cuota.monto)
        }
      }

      // EVENT TRACK - Universal Analytics
      // EVENT UPDATE - 037
      this.$gtm.trackEvent({
        event: 'virtualEvent',
        category: 'Zona Segura',
        action: 'Mis pagos - Pagar seguro - Paso 1',
        label: this.polizaSeleccionada.name + ' - Cuotas - ' + numeroCuotas
      })
      // EVENT TRACK - GA4
      // EVENT UPDATE - 037
      this.$gtm.trackEvent({
        event: 'select_button',
        'Nombre Sección': 'Zona Segura',
        TipoElemento: 'Botón',
        TipoAccion: 'Mis pagos - Pagar seguro - Paso 1',
        CTA: this.polizaSeleccionada.name + ' - Cuotas - ' + numeroCuotas
      })
      this.paymentTotal = parseFloat(total).toFixed(2)
      if (cuota.selected && cuota.rows.filter(c => c.procesoCobranza === 1).length > 0) {
        this.$swal({
          title: 'Información importante',
          text: 'Esta cuota se encuentra en un proceso de cobranza activo, se podría generar un pago duplicado. Por favor, revisa los cargos en tu tarjeta.',
          confirmButtonText: 'Entendido'
        })
      }
    },
    sortByPeriodo (a, b) {
      if (a.fecha < b.fecha) { return 1 }
      if (a.fecha > b.fecha) { return -1 }
      return 0
    },
    sortByName (a, b) {
      if (a.name > b.name) { return 1 }
      if (a.name < b.name) { return -1 }
      return 0
    },
    getPolizasCustomer () {
      let self = this
      self.loader2 = true
      self.txtLoader2 = 'Obteniendo información...'
      self.allPolicies = []
      // let data = { dni: self.basicInfo.numeroDocumento }
      localStorage.removeItem(KEY_PAYMENT_SUCCESS)
      localStorage.removeItem(KEY_CVC_SUCCESS)
      let callback = (policies) => {
        if (policies.length > 0) {
          self.$root.$emit('isAvailableForMakePayments', {})
        }
        self.allPolicies = policies.filter(f => { return (f.ramo === 'Vida' || (f.oriProducto !== null && (f.oriProducto || '').toLowerCase().includes('vehicular'))) && Rules.QuotesPayment.filterPoliciesPaymentAvailable(f) })
        self.getPaymentQuotes({policies: self.allPolicies.map(f => f.numeroPoliza)}).then(res => {
          self.loader2 = false
          /* REMOVER_TEST */
          let withPrestamo = false
          if (res.status === 200 && res.data.codigoRespuesta === '01') {
            let polizasDisponibles = []
            // self.polizasDisponibles =
            self.allPolicies.forEach(item => {
              let poliza = {}
              let info = res.data.policies[item.numeroPoliza]
              let nameOri = this.removeAcents(item.producto.toLowerCase()).split(' ').join('_')
              let ramo = this.removeAcents(item.ramo.toLowerCase()).split(' ').join('_')
              let image = 'vida'
              if (nameOri !== '' && (!this.productsIcons[nameOri] || this.productsIcons[nameOri] === null) && (this.productsIcons[ramo] || this.productsIcons[ramo] !== null)) {
                image = (nameOri === 'educacion_garantizada') ? nameOri : ramo
              }
              poliza.policyNumber = item.numeroPoliza
              poliza.name = item.producto
              poliza.nameOri = nameOri
              poliza.image = image
              poliza.ramo = item.ramo
              poliza.oriProducto = item.oriProducto
              poliza.selected = false
              poliza.flagPagoEfectivo = item.flagPagoEfectivo
              poliza.monedaSimbolo = (item.primaProgramadaMoneda.toUpperCase() === 'US DOLAR') ? '$' : 'S/'
              poliza.pendingQuotes = 0 // info.pago.cuotas.filter(c => c.tipo.toLowerCase() === 'vencida').length
              poliza.info = info
              poliza.cuotas = []
              poliza.viaDeCobro = item.viaDeCobro
              if (info && info !== null) {
                let cuotas = []
                const cuotasPendientes = info.pago.cuotas.filter((value, index, self) =>
                  index === self.findIndex((t) => (
                    t.oi === value.oi
                  ))
                )
                for (let cuota of cuotasPendientes) {
                /* for (let cuota of info.pago.cuotas) { */
                  let found = false
                  withPrestamo = withPrestamo || (cuota.descConcepto || '').toLowerCase().includes('prestamo')
                  for (let i = 0; i < cuotas.length; i++) {
                    if (cuota.mes === cuotas[i].mes) {
                      found = true
                      cuotas[i].monto += Number.parseFloat(cuota.monto.toFixed(2))
                      cuotas[i].rows.push(cuota)
                    }
                  }
                  if (!found) {
                    cuotas.push({monto: Number.parseFloat(cuota.monto.toFixed(2)), mes: cuota.mes, tipo: cuota.tipo, selected: false, rows: [cuota]})
                    poliza.pendingQuotes += (cuota.tipo.toLowerCase() === 'vencida') ? 1 : 0
                  }
                }
                poliza.cuotas = cuotas
              }
              poliza.historial = (res.data.paymentsHistory[item.numeroPoliza] || []).map(h => {
                const [d, m, y] = h.fechaInicioCobertura.split('/')
                const [mm, yy] = h.mes.split(' ')
                h.fecha = new Date(parseInt(y), parseInt(m) - 1, parseInt(d))
                h.mes = mm + ' ' + (y || yy)
                return h
              }).sort(self.sortByPeriodo)
              // (res.data.paymentsHistory[item.numeroPoliza]) ? res.data.paymentsHistory[item.numeroPoliza] : []
              if (poliza.historial.length > 0 || poliza.cuotas.length > 0) {
                polizasDisponibles.push(poliza)
              }
            })
            self.polizasDisponibles = polizasDisponibles.sort(self.sortByName)
            if (polizasDisponibles.filter(x => !!x.info).length === 0) {
              if (Functionalities.isAvailable(Functionalities.vida.CUOTAS_PENDIENTES, self.functionsRules, self)) {
                self.$swal({
                  imageUrl: this.icons.error,
                  title: 'Información importante',
                  text: 'Actualmente no tiene cuotas pendientes',
                  confirmButtonText: 'Entendido'
                })
              }
            } else {
              setTimeout(() => {
                self.showImportant = withPrestamo
              }, 500)
            }
          } else if (res.status === 200 && res.data.codigoRespuesta === '97') {
          // TRACK EVENT - GA
          // this.$gtm.trackEvent(this.trackEvents.policiesNotFound)
          // TRACK EVENT - AMPLITUDE
          /*
          this.$amplitude.getInstance()
            .logEvent(
              this.amplitude.events.cVCChangeError,
              {
                'Seguros Seleccionados': '',
                'Emisor de la Tarjeta': '',
                'Frecuencia de Pago': '',
                'Cuota a Pagar': ''
              }
            )
          */
            self.$swal({
              imageUrl: this.icons.error,
              title: '¡Lo sentimos!',
              html: 'Este trámite no puede ser atendido por este medio, comunícate <a href="' + this.links.WhatsApp + '" target="_blank" class="omnesMedium">aquí</a>.',
              confirmButtonText: 'Entendido'
            }).then((result) => {
              this.$router.push('/inicio')
            })
          } else {
          // TRACK EVENT - GA
          // self.$gtm.trackEvent(this.trackEvents.policiesError)
          // TRACK EVENT - AMPLITUDE
          /*
          self.$amplitude.getInstance()
            .logEvent(
              self.amplitude.events.cVCChangeError,
              {
                'Seguros Seleccionados': '',
                'Emisor de la Tarjeta': '',
                'Frecuencia de Pago': '',
                'Cuota a Pagar': ''
              }
            )
          */
            self.$swal({
              title: '¡Oops, algo salió mal!',
              html: 'Inténtalo más tarde o comunícate <a href="' + this.links.WhatsApp + '" target="_blank" class="omnesMedium">aquí</a>.',
              imageUrl: this.icons.oops,
              confirmButtonText: 'Entendido'
            }).then(() => {
              self.$router.push('/inicio')
            })
          }
        })
          .catch(() => {
            self.loader2 = false
          /*
          // TRACK EVENT - GA
          self.$gtm.trackEvent(this.trackEvents.policiesError)
          // TRACK EVENT - AMPLITUDE
          self.$amplitude.getInstance()
            .logEvent(
              self.amplitude.events.cVCChangeError,
              {
                'Seguros Seleccionados': '',
                'Emisor de la Tarjeta': '',
                'Frecuencia de Pago': '',
                'Cuota a Pagar': ''
              }
            )
          self.$swal({
            title: '¡Oops, algo salió mal!',
            html: 'Inténtalo más tarde o comunícate <a href="' + this.links.WhatsApp + '" target="_blank" class="omnesMedium">aquí</a>.',
            imageUrl: this.icons.oops,
            confirmButtonText: 'Entendido'
          }).then(() => {
            self.$router.push('/inicio')
          })
          */
          })
      }
      if (!self.polizasInfo || self.polizasInfo === null) {
        self.getPolizasVidaVehicular().then(res => {
          callback(res.data.polizas)
        })
      } else {
        callback(self.polizasInfo)
      }
    },
    loadNiubizSessionKey (callback) {
      let self = this
      // El BFF resuelve la apiKey y el comercio a partir de la póliza; el navegador no los envía
      let data = { ...self.niubiz.dataSession, numeroPoliza: self.polizaSeleccionada.policyNumber }
      self.getSessionKey(data).then(res => {
        if (res.status === 200 && res.data.code === '01') {
          self.niubiz.configuration.merchantid = res.data.data.merchantId
          localStorage.setItem('merchant_id', res.data.data.merchantId)
          self.$store.state.user.niubizSessionKey = res.data.data.sessionKey
          callback(res.data.data.sessionKey)
          // self.trackEvents.accessForm.producto = this.polizaSeleccionada.policyNumber
          // TRACK EVENT - GA
          // self.$gtm.trackEvent(this.trackEvents.accessForm)
        }
      })
        .catch(error => {
          self.loader = false

          self.eventLog({
            categoria: 'Funcionalidad',
            nombre: 'Pago de cuotas - Front Error',
            datos: {error, tipo: 'niubiz form'}
          })
          // self.trackEvents.formError.producto = this.polizaSeleccionada.policyNumber
          // TRACK EVENT - GA
          // self.$gtm.trackEvent(this.trackEvents.formError)
          // TRACK EVENT - AMPLITUDE

          self.$amplitude.getInstance()
            .logEvent(
              Amplitude.PaymentQuotes.events.errorLoadNiubiz, {
                'Error': 'Error al obtener la sesión de Niubiz',
                'Detalle': error
              }
            )
          self.$swal({
            title: '¡Oops, algo salió mal!',
            html: 'Inténtalo más tarde o comunícate <a href="' + this.links.WhatsApp + '" target="_blank" class="omnesMedium">aquí</a>.',
            imageUrl: this.icons.oops,
            confirmButtonText: 'Entendido'
          }).then((result) => {
            this.$router.push('/inicio')
          })
        })
    },
    loadFormNiubiz () {
      let self = this
      let callback = function (sk) {
        self.niubiz.configuration.sessionkey = sk
        localStorage.setItem('niubizSessionKey', sk)
        self.loader = false
        self.dialogCardIndications = true
        self.niubiz.finishGetSessionKey = true
      }
      self.loadNiubizSessionKey(callback)
    },
    pageReload () {
      this.$router.go(0)
    },
    // EVENTOS DEL COMPONENT NIUBIZ
    showTerms () {
      this.dialogTerms = true
    },
    changeCheckRecurrent (evt) {
      // this.dialogTerms = true
      localStorage.setItem(RECURRENT_AFFILIATION, (evt.checked) ? VALUE_YES : VALUE_NO)
      this.$store.commit('payments/setSubscribe', evt.checked)
    },
    showLoader (evt) {
      this.loader2 = true
      this.txtLoader2 = evt.message || 'Corroborando tarjeta ingresada...'
    },
    hideLoader () {
      this.loader2 = false
    },
    goToPayment () {
      let poliza = {
        policyNumber: this.paymentsInfo.polizaSeleccionada.policyNumber,
        name: this.paymentsInfo.polizaSeleccionada.info.producto,
        policyName: this.paymentsInfo.polizaSeleccionada.info.productoAcsele,
        charge: this.paymentsInfo.polizaSeleccionada.info.pago.frecuencia,
        paymentMethod: 'pdc',
        quota: this.paymentsInfo.polizaSeleccionada.info.pago.monto,
        coin: this.paymentsInfo.polizaSeleccionada.info.pago.moneda,
        coinSymbol: this.paymentsInfo.polizaSeleccionada.monedaSimbolo
      }
      localStorage.removeItem(KEY_PAYMENT_SUCCESS)
      localStorage.removeItem(KEY_CVC_SUCCESS)
      localStorage.removeItem(KEY_PAYMENT_RETRIES)
      localStorage.removeItem(KEY_CVC_RETRIES)
      this.$router.push({ name: 'PaymentMehodChange', params: { polizasInfo: poliza } })
    },
    onPaymentError (evt) {
      // error niubiz
      // this.trackEvents.serverError.producto = self.polizaSeleccionada.name
      // this.$gtm.trackEvent(this.trackEvents.formError)
      // console.log('Error niubiz: ', evt)
      const self = this
      self.eventLog({
        categoria: 'Funcionalidad',
        nombre: 'Pago de cuotas - Front Error',
        datos: {error: evt, tipo: 'niubiz'}
      })
      // #004.41: Elemento - Intención de pago
      this.intentionToPayAnalytics('Error')
      self.loader2 = false
      this.$swal({
        imageUrl: this.icons.oops,
        title: '¡Parece que algo salió mal!',
        text: 'Te pedimos disculpas por el inconveniente. Por favor, inténtalo nuevamente en unos minutos.',
        confirmButtonText: 'Entendido'
      }).then(() => {
        self.loader2 = false
        self.retryPayment()
      })
    },
    retryPayment () {
      let self = this
      self.$router.replace('/pago-de-cuotas')
      self.$router.go(0)
      /*
      self.loader = true
      self.polizaSeleccionada = self.paymentsInfo.polizaSeleccionada
      self.paymentTotal = parseFloat(self.paymentsInfo.paymentTotal)
      let retry = localStorage.getItem(KEY_PAYMENT_RETRIES) || '0'
      retry = (parseInt(retry) + 1) + ''
      localStorage.setItem(KEY_PAYMENT_RETRIES, retry)
      self.niubiz.configuration.merchantid = localStorage.getItem('merchant_id')
      self.niubiz.dataSession.apiKey = localStorage.getItem('apiKey')
      // COMPLETANDO INFORMACIÓN DE POLIZA
      self.niubiz.configuration.purchasenumber = new Date().getTime() + ''
      self.niubiz.configuration.amount = parseFloat(self.paymentsInfo.paymentTotal)
      self.niubiz.configuration.recurrentmaxamount = parseFloat(self.paymentsInfo.paymentTotal)
      // COMPLETANDO INFORMACIÓN DE CLIENTE
      self.niubiz.pagador.name = self.removeAcents(self.basicInfo.nombres).slice(0, 24)
      self.niubiz.pagador.lastName = self.removeAcents(self.basicInfo.apellidoPaterno + ' ' + self.basicInfo.apellidoMaterno).slice(0, 24)
      self.niubiz.pagador.email = self.basicInfo.correo
      self.niubiz.pagador.alias = self.removeAcents(self.basicInfo.nombres).slice(0, 24)
      self.niubiz.pagador.userBlockId = self.basicInfo.numeroDocumento
      // COMPLETANDO INFORMACIÓN DE PAGO
      self.niubiz.dataSession.currency = self.paymentsInfo.polizaSeleccionada.info.pago.moneda
      self.niubiz.dataSession.amount = parseFloat(self.paymentsInfo.paymentTotal)
      // - INFORMACION: http://mdd.evirtuales.com/ con código 6300

      // SETEANDO ADICIONALES PARAMETROS
      self.sectionEnterDataPayment = true
      const sk = localStorage.getItem('niubizSessionKey')
      self.$store.state.user.niubizSessionKey = sk
      self.niubiz.configuration.sessionkey = sk
      // self.dialogCardAdmited = true
      self.niubiz.finishGetSessionKey = true
      */
      /*
      self.trackEvents.accessForm.producto = this.polizasSeleccionadas[0].policyNumber
      // TRACK EVENT - GA
      self.$gtm.trackEvent(this.trackEvents.accessForm)
      */
      /*
      setTimeout(function () {
        self.loadFormNiubiz()
      }, 1000)
      */
    },
    now () {
      let date = new Date()

      let day = date.getDate()
      let month = date.getMonth() + 1
      let year = date.getFullYear()
      return `${(day < 10) ? '0' : ''}${day}/${(month < 10) ? '0' : ''}${month}/${year}`
    },
    // #004.39: Elemento - Seleccionar Pestañas
    selectTabAnalytics (tab) {
      this.$gtm.trackEvent({
        'event': 'virtualEvent',
        'category': 'Zona Segura',
        'action': 'Mis pagos - Pagar seguro - Paso 1',
        'label': `${this.polizaSeleccionada.name} - Seleccionar Pestaña - ${tab}`
      })

      this.$gtm.trackEvent({
        'event': 'select_tab',
        'Nombre Sección': 'Zona Segura',
        'TipoElemento': 'Botón',
        'TipoAccion': 'Mis pagos - Pagar seguro - Paso 1',
        'CTA': `${this.polizaSeleccionada.name} - Seleccionar Pestaña - ${tab}`
      })
    },
    // #004.41: Elemento - Intención de pago
    intentionToPayAnalytics (resultPay) {
      let cantidad = 0

      if (resultPay === 'Exitoso') {
        for (let cuota of this.paymentsInfo.polizaSeleccionada.cuotas) {
          if (cuota.selected) {
            cantidad++
          }
        }
      }

      this.$gtm.trackEvent({
        'event': 'virtualEvent',
        'category': 'Zona Segura',
        'action': 'Mis pagos - Ingresa los datos de tu tarjeta',
        'label': `${this.paymentsInfo.polizaSeleccionada.name} - Intención de pago`
      })

      this.$gtm.trackEvent({
        'event': 'select_button',
        'Nombre Sección': 'Zona Segura',
        'TipoElemento': 'Botón',
        'TipoAccion': 'Mis pagos - Ingresa los datos de tu tarjeta',
        'CTA': `${this.paymentsInfo.polizaSeleccionada.name} - Intención de pago`,
        'CuotasPendientes': (this.paymentsInfo.polizaSeleccionada.pendingQuotes - cantidad),
        'ResultadoPago': resultPay,
        'TipoError': ''
      })
    },
    // #004.42: Elemento - Pago exitoso
    successfulPaymentAnalytics () {
      this.$gtm.trackEvent({
        'event': 'virtualEvent',
        'category': 'Zona Segura',
        'action': 'Mis pagos - Ingresa los datos de tu tarjeta',
        'label': `${this.paymentsInfo.polizaSeleccionada.name} - Pago exitoso`
      })

      this.$gtm.trackEvent({
        'event': 'select_button',
        'Nombre Sección': 'Zona Segura',
        'TipoElemento': 'Botón',
        'TipoAccion': 'Mis pagos - Ingresa los datos de tu tarjeta',
        'CTA': `${this.paymentsInfo.polizaSeleccionada.name} - Pago exitoso`
      })
    },
    // #004.43: Elemento - Error - Seleccionar Botón
    selectButtonAnalytics () {
      this.$gtm.trackEvent({
        'event': 'virtualEvent',
        'category': 'Zona Segura',
        'action': 'Mis pagos - Ingresa los datos de tu tarjeta',
        'label': `${this.paymentsInfo.polizaSeleccionada.name} - Parece que algo salió mal`
      })

      this.$gtm.trackEvent({
        'event': 'select_button',
        'Nombre Sección': 'Zona Segura',
        'TipoElemento': 'Botón',
        'TipoAccion': 'Mis pagos - Ingresa los datos de tu tarjeta',
        'CTA': `${this.paymentsInfo.polizaSeleccionada.name} - Parece que algo salió mal`
      })
    },
    // #004.46: Purchase
    purchaseAnalytics () {
      let cantidad = 0
      let priceTotal = parseFloat(this.paymentsInfo.paymentTotal).toFixed(2)
      let price = parseFloat(this.paymentsInfo.polizaSeleccionada.cuotas[0].monto).toFixed(2)

      for (let cuota of this.paymentsInfo.polizaSeleccionada.cuotas) {
        if (cuota.selected) {
          cantidad++
        }
      }

      const idPurchase = Math.floor(Math.random() * (99999 - 10000 + 1)) + 10000

      this.$gtm.trackEvent({
        'event': 'orderPurchase',
        'dimension10': cantidad,
        'ecommerce': {
          'currencyCode': 'USD',
          'purchase': {
            'actionField': {
              'id': idPurchase,
              'revenue': parseFloat(priceTotal),
              'coupon': ''
            },
            'products': [{
              'id': this.paymentsInfo.polizaSeleccionada.policyNumber,
              'name': this.paymentsInfo.polizaSeleccionada.name,
              'price': parseFloat(price),
              'brand': 'Interseguro',
              'category': 'Zona Segura',
              'variant': 'Póliza',
              'quantity': 1
            }]
          }
        }
      })

      this.$gtm.trackEvent({
        'event': 'purchase',
        'NroCuotas': cantidad,
        'ecommerce': {
          'transaction_id': idPurchase,
          'value': parseFloat(priceTotal),
          'coupon': '',
          'currency': 'USD',
          'items': [{
            'item_id': this.paymentsInfo.polizaSeleccionada.policyNumber,
            'item_name': this.paymentsInfo.polizaSeleccionada.name,
            'price': parseFloat(price),
            'item_brand': 'Interseguro',
            'item_category': 'Zona Segura',
            'item_variant': 'Póliza',
            'quantity': 1
          }]
        }
      })
    },
    selectMedioDePago (item) {
      this.medioDePago = item
      this.btnPagoEfectivo = this.medioDePago !== '1' && this.medioDePago !== '2'
    },
    goToConfirm () {
      /* cliente: correo y celular registrado */
      const self = this
      const paymentMethod = this.medioDePago === '1' ? Functionalities.vida.PAGO_CUOTAS : Functionalities.vida.PAGO_EFECTIVO
      if (!Functionalities.isAvailable(paymentMethod, self.functionsRules, self)) {
        return
      }
      if (this.basicInfo.correo) {
        if (this.medioDePago === '1') {
          this.goToConfirmChange()
        } else if (this.medioDePago === '2' && this.basicInfo.celular) {
          this.correoPagoEfectivo = this.basicInfo.correo
          this.getPagoEfectivo()
        } else if (this.medioDePago === '2' && !this.basicInfo.celular) {
          this.switchActualizarDatos = true
        }
      } else {
        this.switchActualizarDatos = true
      }
    },
    confirmacionCodigoPago () {
      this.pagoEfectivoDetalle = false
    },
    closeCodigoPago () {
      this.loader = true
      this.popupCodigoDetalle = false
      this.$router.push('/inicio')
      this.loader = false
    },
    metodoDePago () {
      this.pagoEfectivoDetalle = true
    },
    closeActualizarDatos () {
      this.switchActualizarDatos = false
    },
    showloader (evt) {
      this.loader2 = true
      if (evt) {
        this.txtLoader2 = evt.message
      } else {
        this.txtLoader2 = 'Corroborando tarjeta ingresada...'
      }
    },
    hideloader () {
      this.loader2 = false
    }
  },
  created () {
    const backReturn = localStorage.getItem(KEY_BACK_RETURN)
    const paymentsSuccess = localStorage.getItem(KEY_PAYMENT_SUCCESS)
    let queryParams = this.$route.query
    if (backReturn === VALUE_YES) {
      localStorage.setItem(KEY_BACK_RETURN, VALUE_NO)
      if (queryParams.bin == null && queryParams.channel == null && queryParams.transactionToken == null) {
        this.pageReload()
        localStorage.setItem(KEY_PAYMENT_SUCCESS, VALUE_NO)
      }
    } else if (!(queryParams.bin == null && queryParams.channel == null && queryParams.transactionToken == null) || paymentsSuccess === VALUE_YES) {
      this.dialogCVC = false
      localStorage.setItem(KEY_BACK_HOME, VALUE_NO)
    } else {
      this.dialogCVC = true
      localStorage.setItem(KEY_BACK_HOME, VALUE_NO)
    }

    this.$root.$on('showloader', (evt) => {
      this.loader2 = true
      if (evt) {
        this.txtLoader2 = evt.message
      } else {
        this.txtLoader2 = 'Corroborando tarjeta ingresada...'
      }
    })
    this.$root.$on('hideloader', () => {
      this.loader2 = false
    })
  },
  mounted () {
    let self = this
    self.niubiz.dataSession.clientIP = this.ipInfo || localStorage.setItem(IP_ADDR) || self.niubiz.dataSession.clientIP
    this.windowInnerWidth = window.innerWidth
    const backHome = localStorage.getItem(KEY_BACK_HOME)
    /*
    if (this.$vuetify.breakpoint.smAndDown) {
      document.querySelectorAll('#container--body-insurance')[0].classList.add('payment-method')
    }
    */
    // SI ESTA EN LOS PRIMEROS PASOS DE CAMBIO, DADO QUE AUN NO TENEMOS PARAMETROS QUE VENGAN DE PAYMENT-API
    let queryParams = this.$route.query
    // let paymentsSuccess = localStorage.getItem(KEY_PAYMENT_SUCCESS)
    // console.log(queryParams, paymentsSuccess)
    if ((queryParams.bin == null && queryParams.channel == null && queryParams.transactionToken == null) || (!queryParams.bin && !queryParams.channel && !queryParams.transactionToken)) {
      // LIMPIENDO EL FORM NIUBIZ PARA SER USADA NUEVAMENTE
      self.$store.commit('payments/setPayments', null)
      // TRACK EVENT - GA
      // this.$gtm.trackEvent(this.trackEvents.access)
      if (backHome !== VALUE_YES) {
        self.getPolizasCustomer()
      }
    /* } else if (paymentsSuccess === VALUE_YES) {
      // MOSTRANDO EL DIALOG DE FINALIZADO
      self.sectionSuccessfullChangePayment = true
    } else if (paymentsSuccess === VALUE_IN_TRANSACT) {
      // MOSTRANDO EL DIALOG DE FINALIZADO
      self.$swal({
        text: 'Esta cuota se encuentra en un proceso de cobranza, podría generar un pago duplicado. Por favor revisa los cargos en tu tarjeta.',
        imageUrl: this.icons.informacion,
        imageHeight: 150,
        imageWidth: 150,
        confirmButtonText: 'Entendido'
      }).then(() => {
        localStorage.setItem(KEY_PAYMENT_SUCCESS, VALUE_NO)
        self.$router.replace('/pago-de-cuotas')
        self.$router.go(0)
      })
    */
    } else {
      // SI YA SOLICITO EL TOKEN. EL REDIRECT VIENE HACIA AQUI PARA SETEAR EL TOKEN
      let transactionToken = queryParams.transactionToken
      let bin = queryParams.bin
      const subscribeInfo = localStorage.getItem(RECURRENT_AFFILIATION) || '0'

      if (!self.paymentsInfo || !self.paymentsInfo.subscription || !self.paymentsInfo.trazabilidad || !self.paymentsInfo.link || !self.paymentsInfo.transaccion) {
        self.$router.replace('/pago-de-cuotas')
        self.$router.go(0)
      }

      // OBTENEMOS EL FORM YA COMPLETADO ANTERIORMENTE Y SETEAMOS EL TOKEN DEL PAYMENT-API
      self.paymentsInfo.token = transactionToken
      self.paymentsInfo.subscription.token = transactionToken
      self.paymentsInfo.bin = bin
      self.paymentsInfo.transaccion.action = (subscribeInfo === '1') ? 'PAGAR Y AFILIAR' : 'PAGAR'
      self.paymentsInfo.subscribe = subscribeInfo === '1'
      self.paymentsInfo.transaccion.transactionID = transactionToken
      self.paymentsInfo.subscription.subscription.metadataAffiliation.tarjeta.numerotarjeta = transactionToken
      self.paymentsInfo.subscription.subscription.metadataAffiliation.tarjeta_pp.numerotarjeta = transactionToken
      self.paymentsInfo.quotesHtml = self.generateTableQuotes(self.paymentsInfo.polizaSeleccionada.cuotas, self.paymentsInfo.polizaSeleccionada.info.pago.monedaSimbolo)
      self.paymentsInfo.prestamos = self.paymentsInfo.prestamos || false

      let eventProperties = {}
      eventProperties[Amplitude.PaymentQuotes.properties.monto] = self.paymentsInfo.polizaSeleccionada.info.pago.moneda + ' ' + self.paymentsInfo.paymentTotal
      eventProperties[Amplitude.PaymentQuotes.properties.tipoTarjeta] = self.getCardBrand(queryParams.bin)
      eventProperties[Amplitude.PaymentQuotes.properties.opcionFormulario] = (subscribeInfo === '1') ? 'Pago y afiliación' : 'Solo pago'
      self.$amplitude.getInstance().logEvent(Amplitude.PaymentQuotes.events.formulario, eventProperties)

      // MOSTRANDO EL DIALOG DE CARGANDO
      self.loader2 = true
      // self.txtLoader2 = 'Corroborando información y generando el cambio...'
      self.txtLoader2 = 'Tu pago se está procesando, por favor no cierres ni actualices la página...'
      // localStorage.setItem(KEY_PAYMENT_SUCCESS, VALUE_IN_TRANSACT)
      self.paymentQuotes(self.paymentsInfo).then(res => {
        if (res.status === 200 && res.data.codigoRespuesta === '96') {
          const error = paymentErrors.niubiz[res.data.objErrorResource.code] || paymentErrors.niubiz['']
          self.loader2 = false

          // #004.41: Elemento - Intención de pago
          this.intentionToPayAnalytics('Error')

          self.$swal({
            title: error.title,
            text: error.message,
            imageUrl: require('@/assets/payments/' + error.image + '.png'),
            imageHeight: 150,
            imageWidth: 150,
            confirmButtonText: 'Entendido'
          }).then(() => {
            // #004.43: Elemento - Error - Seleccionar Botón
            self.selectButtonAnalytics()
            self.loader2 = false
            self.$router.replace('/pago-de-cuotas')
            self.retryPayment()
          })
        } else if (res.status === 200 && res.data.codigoRespuesta !== '01') {
          if (res.data.codigoRespuesta === '03') {
            self.paymentsInfo.paymentResponse = res.data
            self.sectionSelectPolicy = false
            self.sectionSelectQuotes = false
            self.sectionEnterDataPayment = false
            self.sectionVerifyData = false
            self.sectionThankPayment = false
            self.sectionSuccessfullChangePayment = true
            self.onlyPayment = !self.paymentsInfo.subscribe
            self.loader2 = false
            self.email_send_constancy = self.basicInfo.correo
          }

          // #004.41: Elemento - Intención de pago
          self.intentionToPayAnalytics('Exitoso')

          // #004.42: Elemento - Pago exitoso
          self.successfulPaymentAnalytics()

          // #004.46: Purchase
          self.purchaseAnalytics()
          const error = paymentErrors.niubiz[res.data.objErrorResource.code] || paymentErrors.niubiz['']
          self.$swal({
            title: error.title,
            text: error.message,
            imageUrl: require('@/assets/payments/' + error.image + '.png'),
            imageHeight: 150,
            imageWidth: 150,
            confirmButtonText: 'Entendido'
          }).then(() => {
            self.loader2 = false
            if (res.data.codigoRespuesta === '02') {
              self.$router.replace('/pago-de-cuotas')
              self.$router.go(0)
            }
          }).catch(() => {})
        } else if (res.status === 200 && res.data.codigoRespuesta === '01') {
          localStorage.setItem(KEY_PAYMENT_SUCCESS, VALUE_YES)
          localStorage.removeItem(KEY_PAYMENT_RETRIES)
          localStorage.removeItem(RECURRENT_AFFILIATION)
          localStorage.removeItem('merchant_id')
          localStorage.removeItem('apiKey')
          localStorage.removeItem('niubizSessionKey')
          self.$router.replace('/pago-de-cuotas')

          let eventProperties = {}
          eventProperties[Amplitude.PaymentQuotes.properties.producto] = self.paymentsInfo.polizaSeleccionada.ramo
          eventProperties[Amplitude.PaymentQuotes.properties.subproducto] = self.paymentsInfo.polizaSeleccionada.oriProducto
          eventProperties[Amplitude.PaymentQuotes.properties.poliza] = self.paymentsInfo.polizaSeleccionada.policyNumber
          eventProperties[Amplitude.PaymentQuotes.properties.monto] = self.paymentsInfo.polizaSeleccionada.info.pago.moneda + ' ' + self.paymentsInfo.paymentTotal
          this.$amplitude.getInstance().logEvent(Amplitude.PaymentQuotes.events.pago, eventProperties)

          // #004.41: Elemento - Intención de pago
          this.intentionToPayAnalytics('Exitoso')

          // #004.42: Elemento - Pago exitoso
          this.successfulPaymentAnalytics()

          // #004.46: Purchase
          this.purchaseAnalytics()

          self.paymentsInfo.paymentResponse = res.data
          self.sectionSelectPolicy = false
          self.sectionSelectQuotes = false
          self.sectionEnterDataPayment = false
          self.sectionVerifyData = false
          self.sectionThankPayment = false
          self.sectionSuccessfullChangePayment = true
          self.onlyPayment = !self.paymentsInfo.subscribe
          self.loader2 = false
          self.email_send_constancy = self.basicInfo.correo
          /* if (process.env.ENVIRONMENT === 'prod') {
            self.makeSendEmail()
            self.$router.replace('/pago-de-cuotas')
          } */
          self.$swal({
            title: 'Estimado cliente',
            text: 'En breve se actualizará tu pago.',
            confirmButtonText: 'Entendido'
          }).then(() => {}).catch(() => {})
        } else {

        }
      }).catch((err) => {
        self.eventLog({
          categoria: 'Funcionalidad',
          nombre: 'Pago de cuotas - Front Error',
          datos: {error: err, tipo: 'pago de cuotas'}
        })

        // #004.41: Elemento - Intención de pago
        self.intentionToPayAnalytics('Error')

        self.$swal({
          imageUrl: this.icons.oops,
          title: '¡Parece que algo salió mal!',
          text: 'Te pedimos disculpas por el inconveniente. Por favor, inténtalo nuevamente en unos minutos.',
          confirmButtonText: 'Entendido'
        }).then(() => {
          // #004.43: Elemento - Error - Seleccionar Botón
          self.loader2 = false
          self.selectButtonAnalytics()
          self.$router.replace('/pago-de-cuotas')
          self.retryPayment()
        })
      })
    }

    self.$root.$emit('npsInactivity', {seccion: 'Mis pagos'})
  },
  computed: {
    ...mapGetters('user', ['polizasInfo', 'basicInfo', 'niubizSessionKey', 'ipInfo', 'functionsRules']),
    ...mapGetters('payments', ['paymentsInfo'])
  },
  beforeDestroy: function () {
    /*
    if (this.$vuetify.breakpoint.smAndDown) {
      document.querySelectorAll('#container--body-insurance')[0].classList.remove('payment-method')
    }
    */
  },
  components: {
    Niubiz,
    PaymentTermsConditions,
    PagoEfectivo,
    PagoEfectivoPopupDetalle,
    CodigoPago,
    ActualizarDatos
  }
}
</script>

<style>
  @import url('../assets/css/payments.css');
  .container {
    padding: 25px;
  }
  .only-desktop {
    display: block;
  }
  .only-mobile {
    display: none;
  }

  @media only screen and (max-width: 600px) {
    #main-cvc-content .flex .layout .flex .v-card.v-sheet {
      margin-bottom: 1em;
    }

    .only-desktop {
      display: none;
    }
    .only-mobile {
      display: flex;
    }
  }

  .scroll-policies {
    padding-right: 10px;
    max-height: 400px;
    overflow-x: hidden;
    overflow-y: auto;
  }
  @media only screen and (max-width: 500px) {
    .policies-horizontal {
      min-width: 95%;
    }
    .scroll-policies {
      display: flex;
      overflow: scroll;
      padding-bottom: 0px;
      width: 100%;
      gap: 15px;
    }
  }
  .card-items-pdc {
    /* background: #FFFFFF; */
    /* border: 1.67837px solid #F2F2F2; */
    box-sizing: border-box;
    box-shadow: none;
    /* box-shadow: 0px 3.05063px 6px rgb(159 159 159 / 16%); */
    /* border-radius: 17px; */
    /* margin-top: 10px; */
    /* cursor: pointer; */
    width: 100%;
  }
  .card-items-pdc-selected {
    border: 1.5px solid #0855C4;
    cursor: pointer;
  }

  .p-red {
    color: #EB5757 !important;
  }

  .p-cyan {
    color: var(--second-brand-color) !important;
  }

  .p-green {
    color: #40C2A6 !important;
  }

  .inicio-main-dash-payment .icon-product {
    /* margin-left: 10px; */
    width: 70px;
    display: flex;
  }
  .inicio-main-dash-payment .detail-product {
    min-width: 205px;
  }

  .img-product-pdc {
    height: 60px;
    width: 53px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
  }

  .title-pdc {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 19px;
    text-align: center;
    /* letra titulos */
    color: #212529;
  }

  .inicio-main-dash-payment .v-card__title {
    margin-bottom: 7px;
    padding: 0;
    font-size: 18px;
  }

  .inicio-main-dash-payment .list-container .box-information {
    padding: 0 16px;
  }
  .inicio-main-dash-payment .list-container .box-information .layout{
    justify-content: space-between;
  }
  .inicio-main-dash-payment .box-information .ly-item-data-poliza p {
    font-size: 16px;
    margin-bottom: 0;
    margin-right: 10px;
  }

  .item-pdc-number {
    font-family: Omnes Pro;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 17px;
    text-align: center;
  }

  .flex.policies-horizontal {
    display: flex;
    /* overflow: scroll; */
    /* padding-bottom: 11px; */
    width: 100%;
  }

  .policies-article {
    min-width:100%;
    padding-left: 5px;
    padding-right: 10px;
    overflow-x: auto;
  }

  .flex.policies-horizontal-only-one {
    overflow: unset;
  }

  .flex.policies-article-only-one {
    width: 100%;
    padding-left: 0px;
    padding-right: 0px;
  }

  .arrow-bottom{
    transform: rotate(90deg);
    transition: .3s ease-in-out;
  }

  table.pdcTable {
    margin-top: 10px;
    width: 100%;
    text-align: center;
    border-collapse: collapse;
    border: 1px solid #C9C9C9;
    border-radius: 1rem;
    overflow: auto;
  }
  table.pdcTable td, table.pdcTable th {
    border: none;
    border-bottom: 1px solid #C9C9C9;
    padding: 15px 0px;
  }
  table.pdcTable thead {
    background: #0855C4;
  }
  table.pdcTable thead th {
    font-weight: bold;
    color: #FFFFFF;
    text-align: center;
  }

  .cuota-vencida {
    border: 1px solid var(--fuchsia-color);
    background: var(--fuchsia-color);
    box-sizing: border-box;
    color: #fff;
    border-radius: 17px;
    font-weight: 500;
    font-size: 12px;
    line-height: 13px;
    text-align: center;
    padding: 5px 18px;
  }

  .cuota-disponible {
    border: 1px solid #40C2A6;
    color: #40C2A6;
    box-sizing: border-box;
    border-radius: 17px;
    font-weight: 500;
    font-size: 12px;
    line-height: 13px;
    text-align: center;
    padding: 5px 10px;
  }

  .btn-process-all-floating  {
    position: fixed;
    bottom: 0;
    width: 100%;
    left: 0;
    margin: 0;
    margin-bottom: 20px;
    background-color: #FFF;
    z-index: 10;
  }

  .back-purple {
    background: var(--fuchsia-color) !important;
    color: #FFF !important;
    padding-left: 30px;
    padding-right: 30px;
    text-transform: initial;
  }

  .info-creditcard {
    margin-top: 25px;
  }

  .successfull-card {
    background-color: #E2ECF7;
    border: 1px solid #0855C4;
    box-sizing: border-box;
    padding-bottom: 18px;
  }

  .ly-success-info {
    background-color: #E2ECF7;
  }

  p.omnesRegularDetail {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 17px;
    color: #535D66;
  }

  p.omnesBoldDetail {
    font-style: normal;
    font-weight: bold;
    font-size: 17px;
    line-height: 17px;
    color: #535D66;
  }

  .to-center {
    width: 100%;
    text-align: center;
  }

  .to-left {
    width: 100%;
    text-align: left;
  }

  .to-right {
    width: 100%;
    text-align: right;
  }

  .detail-content {
    padding-left: 20px;
    padding-right: 20px;
  }

  .horizontal-line {
    border-top: 0.1px solid #C9C9C9;
  }

  p.link {
    margin-top: 20px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 15px;
    text-decoration-line: underline;
    color: var(--second-brand-color);
    cursor: pointer;
  }
  .inicio main .container{
    padding: 0!important;
  }
  .inicio-panel-block-1 h2,
  .inicio-panel-block-2 h2{
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 2px;
  }
  .inicio-panel-block-1-btn{
    align-items: center;
    background: white;
    border: 1.59px solid #F2F2F2;
    box-shadow: 0px 2.89px 2.89px rgba(112, 112, 112, 0.25);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    height: 37px;
    width: 37px;
  }

  .inicio-panel-banner{
    align-items: center;
    background-color: #0855C4;
    border-radius: 16px;
    display: flex;
  }
  .inicio-panel-banner h3,
  .inicio-panel-banner p{
    color: white;
  }
  .inicio-panel-banner h3{
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 10px;
  }
  .inicio-panel-banner p{
    font-size: 14px;
    margin-bottom: 0!important;
  }
  .inicio-panel-banner button{
    align-items: center;
    background: var(--fuchsia-color);
    border-radius: 4px;
    display: flex;
    color: white;
    font-family: "Omnes Regular", sans-serif;
    font-weight: 500px;
    font-size: 16px;
    justify-content: center;
    height: 29px;
    width: 190px;
  }
  .inicio-panel-block-1-descrip{
    margin-left: auto;
    margin-right: auto;
    width: 80%;
  }
  .inicio-panel-block-1-descrip svg{
    margin: 2px 0px 0 5px;
  }

  .inicio-panel-pagos-list{
    display: flex;
    flex-wrap: wrap;
  }
  .inicio-panel-pagos article{
    padding-top: 30px;
  }
  .inicio-panel-pagos article p{
    margin-bottom: 0;
  }
  .inicio-panel-pagos article h3{
    color: var(--text-color);
    font-size: 16px;
    font-weight: 500;
  }
  .inicio-panel-pagos article,
  .inicio-panel-contacto article{
    background: #FFFFFF;
    border: 1.67837px solid #F2F2F2;
    box-sizing: border-box;
    box-shadow: 0px 3.05063px 6px rgba(159, 159, 159, 0.16);
    border-radius: 16.8893px;
    margin-top: 10px;
    height: 99px;
    width: 260px;
  }
  .inicio-panel-contacto article{
    padding-top: 5px;
  }
  .inicio-panel-contacto article .g-flex{
    margin-top: 15px;
    margin-left: 23px;
  }
  .inicio-panel-contacto article a{
    color: #0855C4;
    margin-left: 13px;
  }
  .inicio-extra h2{
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 12px;
  }
  .inicio-extra p{
    margin-bottom: 0;
  }
  .inicio-extra article{
    background: #FFFFFF;
    border: 1.41874px solid #F2F2F2;
    box-sizing: border-box;
    box-shadow: 0px 2.57871px 2.57871px rgba(112, 112, 112, 0.25);
    border-radius: 14.2766px;
    width: 100%;
  }
  .inicio-extra section:nth-of-type(1){
    margin-top: 20px;
  }
  .inicio-extra section:nth-of-type(1) article{
    height: 99px;
  }
  .inicio-extra section:nth-of-type(1) article figure{

    width: 125px;
  }
  .inicio-extra section:nth-of-type(1) article div{
    margin-left: 5px;
  }
  .inicio-extra section:nth-of-type(1) p{
    color: var(--text-color);
    font-size: 14px;
    font-weight: 500;
  }

  .inicio-extra section:nth-of-type(2){
    margin-top: 35px;
  }

  .inicio-extra section:nth-of-type(2){
    margin-top: 35px;
  }
  .inicio-extra section:nth-of-type(2) article{
    padding: 7px 15px 5px 15px;
  }

  .inicio-extra section:nth-of-type(2) article:not(:nth-of-type(1)){
    margin-top: 25px;
  }
  .inicio-extra-item-title{
    margin-bottom: 10px;
    margin-top:10px;
  }

  .inicio-extra-item-title p{
     color: var(--text-color);
     font-size: 14px;
  }
  .inicio-extra-item-title p:nth-of-type(2){
    margin-left: 5px;
  }

  .inicio-extra-item-porcent p{
    color: #0855C4;
    font-size:12px;
  }
  .inicio-extra-item-porcent p:nth-of-type(1){
    text-align: right;
  }

  .inicio-extra-item-porcent div,
  .inicio-extra-item-porcent aside{
    border-radius: 8px;
    height: 6px;
  }

  .inicio-extra-item-porcent div{
    background: #D9D9D9;
    margin-bottom: 10px;
    margin-top: 5px;
    position:relative;
    max-width: 260px;
    z-index: 2;
  }
  .inicio-extra-item-porcent aside{
     background: #0855C4;
     left:0;
     position:absolute;
     top:0;
     z-index: 5;
  }
  .inicio-extra-item-fecha{
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }
  .inicio-extra-item-fecha p{
    color: #919191;
    font-size: 14px;
    margin-left: 7px;
  }
  .inicio-extra button{
    align-items: center;
    background: var(--fuchsia-color);
    border-radius: 4px;
    display: flex;
    color: white;
    font-family: "Omnes Regular", sans-serif;
    font-weight: 500px;
    font-size: 16px;
    justify-content: center;
    height: 39px;
    margin: 25px auto 0 auto;
    width: 110px;
  }

  .inicio-main-dash-payment .v-tabs__container {
    height: 36px;
  }

  .inicio-main-dash-payment a.v-tabs__item {
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
    background-color: #F2F2F2;
    color: rgba(83, 93, 102, 0.7);
  }

  .inicio-main-dash-payment a.v-tabs__item.v-tabs__item--active {
    color: #fff;
    background-color: #0855C4;
  }

  /**
      TODA ESTA HOJA DE CSS, PORFA REVISAR PARA NO UAR
      LAS CLASES GLOBALES DIRECTAMENTE SIN UN IDENTIFICADOR
    */
  @media screen and (max-width: 1023px){
    .inicio-main-dash-payment{
      margin: 77px auto 0;
      max-width: 405px;
    }
    .inicio-main-dash-payment .inicio-panel {
      border: none;
    }
    .inicio-panel-content{
      margin:auto;
      width: 90%;
    }
    .inicio-panel-banner{
      padding-bottom: 30px;
      padding-top: 35px;
    }
    .inicio-panel-banner figure{
      margin: auto;
    }
    .inicio-panel-banner img{
      max-width: 100%;
    }
    .inicio-panel-banner article{
      margin-left: 5px;

    }
    .inicio-panel-banner article p {
      padding-right: 15px;
    }
    .inicio-panel-banner button {
      margin-top: 15px;
    }
    .inicio-extra {
      margin: auto;
      padding-bottom: 12px;
      width: 90%;
    }
    .inicio-panel-block-1-list article {
      align-items: center;
      display: flex;
      padding-left: 15px;
      width: 100%;
    }
    .inicio-panel-block-1-list article h3 {
      margin-bottom: 5px;

    }
    .inicio-panel-block-1-list figure {
      margin-bottom: 0;
      padding-top: 10px;
      height: auto;
      width: 27%;
    }
    .inicio-panel-block-1-list article:not(:nth-of-type(1)) {
      margin-top: 20px;
    }
    .inicio-main-dash.payment-quotes .inicio-panel-block-1-descrip {
      margin-left: 15px;
      width: 50%;
    }
    .inicio-panel-pagos-list article,
    .inicio-panel-contacto article {
      width: 100%;
    }
    .inicio-panel-pagos-list .g-flex figure {
      text-align: center;
      width: 93px;
    }
    .inicio-panel-block-1-btn {
      margin: 15px auto 0 auto;
    }

    .inicio-main-dash-payment .main-cvc-content .v-btn {
      height: 50px;
      padding: 16px;
    }
    .inicio-main-dash-payment .main-cvc-content >.layout {
      gap: 20px;
    }
  }
  @media screen and (min-width: 1024px) {
    .inicio {
      background: #F8F8F8;
    }
    .inicio-extra article {
      max-width: 308px;
    }
    .inicio-main-content {
      align-items: flex-start;
      display: flex;
      justify-content: space-between;
      /* margin-left: auto;
      margin-right: auto;
      max-width: 1355px; */
    }
    .inicio-main-dash-payment{
      display: flex;
      justify-content: space-between;
      width: calc(100% - 65px);
    }
    .inicio-main-dash-payment .inicio-panel {
      margin-right: 10px !important;
      margin-left: 10px;
      padding: 25px 50px;
      min-width: 880px;
      height: fit-content ;
    }
    .inicio-main-dash-payment .inicio-extra {
      padding: 0 50px;
    }
    .inicio-main-dash-payment .inicio-panel-content {
      margin: 0 !important;
    }
    .inicio-main-dash-payment .fs-16 {
      font-size: 16px;
    }
    .inicio-main-dash-payment .main-cvc-content >.layout{
      /* gap: 30px; */
      justify-content: space-between;
    }
    .inicio-main-dash-payment .list-container .polizas {
      width: 26rem;
    }

    .inicio-main-dash-payment .card-items-pdc v-card v-sheet theme--light {
      display: flex;
      align-items: center;
    }
    .arrow-bottom {
      transform: none;
    }
    table.pdcTable td, table.pdcTable th {
      padding: 14px 0px;
    }
    /* CONFLICTO CON EL HOME
    .inicio-panel-banner{
      justify-content: space-between;
      padding-left: 50px;
      padding-right: 50px;
    }
    */
    .inicio-panel-banner button{
      height: 39px;
      width: 110px;
    }
    .inicio-panel-banner div{
      margin-right: 70px;
      text-align: center;
    }
    .inicio-panel-banner h3{
      font-size: 24px;
    }
    .inicio-panel-banner p{
      font-size: 18px;
    }
    .inicio-panel-banner article{
      align-items: center;
      display: flex;
    }
    .inicio-panel-block-1-list{
      position: relative;
    }

    .inicio-panel-block-1-btn{
      top: 50%;
      transform: translateY(-50%);
      position: absolute;
      right: -15px;
    }

    .inicio-panel-block-1-list article h3{
      text-align: center;
    }
    .inicio-panel-block-1-list article:not(:nth-of-type(1)){
      margin-left: 17px;
    }
    .inicio-panel-pagos-list article:not(:nth-of-type(1)){
      margin-left: 22px;
    }
    /* .inicio-extra{
      margin-left: 10px;
    } */
    .inicio-panel-contacto {
      margin-left: 15px;
    }
  }
  .cursor-pointer {
    cursor: pointer;
  }

  @media only screen and (max-width: 799px) {
    .inicio-main-dash-payment.payment-quotes .inicio-extra {
      display: none;
    }
    #successfull_change_payment {
      overflow-y: unset;
      max-height: none;
    }
  }

  #successfull_change_payment {
    overflow-y: auto;
    max-height: 600px;
  }

  .affiliation-only {
    max-width: 85%;
    background-color: #0855C4;
    border-radius: 20px;
    margin: 0px auto;
    margin-top: 30px;
    padding: 25px;
  }

  .text-affiliation {
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 24px;
    text-align: justify;
    color: #535D66;
    padding: 25px 65px;
  }

  .affiliation-only figure {
    display: flex;
  }

  .affiliation-only figure p {
    color: #FFF;
    font-style: normal;
    font-weight: normal;
    font-size: 22px;
    line-height: 30px;
    margin-top: 5px;
  }

/** TOOLTIPS */
#popover-info {
  background-color: var(--text-color);
  padding: 4px 6px 5px 6px;
}
#popover-info span,
#popover-info p {
  color: #FFF;
  font-size: 14px;
}

.tooltip-bubble {
  margin-top: 43px;
  contain: initial;
  overflow: visible;
}
.tooltip-bubble::before {
  position: absolute;
  content: "";
  top: 0;
  right: 10px;
  transform: translateY(-100%);
  width: 10px;
  height: 13px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 13px solid var(--text-color);
  margin-right: 20%;
}

#dialog-formalities h3 {
  margin-top: 1em;
}
.v-dialog .dialog-with-inputbox p.subtitle-dialog-min {
  font-size: 11px;
  color: var(--text-color);
  font-weight: bold;
}
.v-dialog .dialog-with-inputbox div.layout.mg-bt-4 {
  margin-bottom: 1em;
}
.dialog-with-inputbox .textfield-benef-fecnac.v-text-field .v-input__control .v-input__slot .v-text-field__slot input {
  margin-right: 0px !important;
}
.v-dialog .dialog-with-inputbox .textfield-benef-apepat {
  margin-right: 4px;
}
.v-dialog .dialog-with-inputbox .textfield-benef-apemat {
  margin-left: 4px;
}
.v-dialog .dialog-with-inputbox .textfield-benef-fecnac {
  margin-right: 4px;
}
.v-dialog .dialog-with-inputbox .textfield-benef-genero {
  margin-left: 4px;
}
.v-dialog .dialog-with-inputbox .textfield-dialog {
  margin-top: 2px;
  padding-top: 2px;
}
.v-dialog .dialog-with-inputbox .textfield-dialog .v-input__slot {
  margin-bottom: 0px;
}
.v-dialog img.imgbtn-icon_close {
  position: absolute;
  right: 0px;
  margin: 1em;
  cursor: pointer;
}
.v-dialog img.img-send_constancy {
  margin-top: 7em;
}
button#btnSendConstancy {
  font-size: 14px;
  border-radius: 3px;
  background-color: var(--fuchsia-color);
  color: #fff;
  text-transform: initial;
  height: auto;
}
button#btnSendConstancy {
  width: 50%;
}
button#btnSolicitud:hover { background-color: #d6058b; }
button#btnSendConstancy .v-btn__content {
  padding: 1em 0;
}
.v-dialog button#btnSendConstancy {
  margin-bottom: 3em;
}

.i-radio--extend.scale{
  transform: scale(2);
}

.inicio-main-dash-payment .polizas .v-card__text {
  padding: 0;
}

.inicio-main-dash-payment .main-cvc-content .v-btn {
  padding: 16px;
  height: 40px;
  padding: 12px 16px;
  border-radius: 4px;
  text-transform: initial;
}

@media only screen and (max-width: 799px) {
  .i-radio--extend.scale {
    transform: scale(1.5);
  }
}

.v-tabs__div {
  text-transform: initial;
}

.v-tabs__bar.theme--light {
    margin-bottom: -13px;
    z-index: 1;
}

/* a.v-tabs__item.v-tabs__item--active {
  color: #535D66;
  background-color: #F2F2F2;
} */

/* a.v-tabs__item.v-tabs__item--active {
  color: #fff;
  background-color: #0855C4;
} */

button.swal2-confirm.btn-response.swal2-styled {
    margin-top: 50px !important;
    margin-bottom: 20px !important;
    height: fit-content !important;
    text-transform: capitalize !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/PaymentQuotes.vue